if(!window.LBF_OFFER_CLOCK){
  let epoch=null, at=0, pending;
  const FALLBACK_TRIO_RETIRE=Date.parse('2026-10-01T00:00:00+08:00');
  const now=()=>epoch===null||performance.now()-at>180000?null:epoch+performance.now()-at;
  /* Soft NO fix: Trio board card + marquee retire at Dinner starts_at (same boundary). Fail closed. */
  let cachedDinnerStart=null;
  const readDinnerStartFromDom=()=>{
    const dinnerCard=document.querySelector('lbf-promo-card[data-key="dinner-box-1010"]');
    if(dinnerCard?.dataset.start&&Number.isFinite(Date.parse(dinnerCard.dataset.start)))return Date.parse(dinnerCard.dataset.start);
    for(const el of document.querySelectorAll('[data-lbf-offer-record]')){
      try{const o=JSON.parse(el.textContent);if(o&&o.kind==='dinner'&&o.start&&Number.isFinite(Date.parse(o.start)))return Date.parse(o.start);}catch(_){}}
    const retireEl=document.querySelector('[data-lbfss-open="trio"][data-retire-at]');
    if(retireEl?.dataset.retireAt&&Number.isFinite(Date.parse(retireEl.dataset.retireAt)))return Date.parse(retireEl.dataset.retireAt);
    return null;
  };
  const dinnerStartMs=()=>{
    const live=readDinnerStartFromDom();
    if(live!=null){cachedDinnerStart=live;return live;}
    if(cachedDinnerStart!=null)return cachedDinnerStart;
    return FALLBACK_TRIO_RETIRE;
  };
  /* Speed fix 12 Oct 2026 (audit 20261012 item 4): the offer records live on the canonical All Meals board
     (/collections/all). Every homepage and All visit used to download that whole page twice (~150 KB + ~1 MB
     parse each). Now: on /collections/all itself the page's own DOM is the source (no fetch); elsewhere ONE
     fetch, shared by the Dinner-start lookup and the dish-page trays, remembered for the visit in
     sessionStorage for OFFER_TTL; the Dinner-start lookup only runs when this page shows something it
     controls (the retired Trio card, links or dialogs). Start/end times are still checked at read time. */
  const OFFER_TTL=120000, OFFER_KEY='lbf_offer_source_v1';
  const offerRoot=()=>window.Shopify?.routes?.root||'/';
  const themeKey=()=>String(window.Shopify?.theme?.id||'');
  const isOfferSourcePage=()=>location.pathname.replace(/\/+$/,'')===(offerRoot()+'collections/all').replace(/\/+$/,'')&&!!document.querySelector('[data-offer-master="true"]');
  const readOfferSource=doc=>{
    const records=[];
    doc.querySelectorAll('[data-lbf-offer-record]').forEach(el=>{try{const o=JSON.parse(el.textContent);if(o)records.push(o);}catch(_){}});
    const retireEl=doc.querySelector('[data-lbfss-open="trio"][data-retire-at]');
    return {records,trioRetireAt:retireEl?retireEl.getAttribute('data-retire-at'):null};
  };
  const offerSourceUrl=()=>{
    let url=offerRoot()+'collections/all?lbf_offer_source='+Math.random().toString(36).slice(2);
    let preview=new URLSearchParams(location.search).get('preview_theme_id');
    if(!preview&&window.Shopify?.theme?.role&&window.Shopify.theme.role!=='main')preview=String(window.Shopify.theme.id);
    if(preview)url+='&preview_theme_id='+encodeURIComponent(preview);
    return url;
  };
  let offerReq=null, offerReqAt=0;
  /* fresh=true (add-to-cart validation) always downloads the current board, as before. */
  const offerSource=fresh=>{
    if(!fresh&&isOfferSourcePage())return Promise.resolve(readOfferSource(document));
    if(!fresh)try{const c=JSON.parse(sessionStorage.getItem(OFFER_KEY)||'null');if(c&&c.theme===themeKey()&&Array.isArray(c.records)&&Date.now()-c.at>=0&&Date.now()-c.at<OFFER_TTL)return Promise.resolve(c);}catch(_){}
    if(!fresh&&offerReq&&Date.now()-offerReqAt<OFFER_TTL)return offerReq;
    offerReqAt=Date.now();
    offerReq=fetch(offerSourceUrl(),{cache:'no-store'})
      .then(r=>{if(!r.ok)throw new Error('Offer source unavailable');return r.text();})
      .then(html=>{const src=readOfferSource(new DOMParser().parseFromString(html,'text/html'));src.at=Date.now();src.theme=themeKey();try{sessionStorage.setItem(OFFER_KEY,JSON.stringify(src));}catch(_){}return src;});
    offerReq.catch(()=>{});
    return offerReq;
  };
  const needsDinnerBoundary=()=>!!document.querySelector('[data-lbfss-open="trio"],[data-lbfss-add="frozen-best-seller-trio"],a[href$="#box-trio"],dialog[id$="-trio"],[data-retire-at][id$="-trio" i]');
  const refreshDinnerStart=()=>{
    const live=readDinnerStartFromDom();
    if(live!=null){cachedDinnerStart=live;return Promise.resolve(live);}
    /* nothing here uses the boundary, or this page IS the source and has none: no download */
    if(!needsDinnerBoundary()||isOfferSourcePage())return Promise.resolve(null);
    return offerSource()
      .then(src=>{
        for(const o of src.records){if(o&&o.kind==='dinner'&&o.start&&Number.isFinite(Date.parse(o.start))){cachedDinnerStart=Date.parse(o.start);return cachedDinnerStart;}}
        if(src.trioRetireAt&&Number.isFinite(Date.parse(src.trioRetireAt))){cachedDinnerStart=Date.parse(src.trioRetireAt);return cachedDinnerStart;}
        return null;
      })
      .catch(()=>null);
  };
  const trioRetired=time=>{const boundary=dinnerStartMs();return time===null||!Number.isFinite(boundary)||time>=boundary;};
  const apply=()=>{
    const time=now();
    const retiredTrio=trioRetired(time);
    document.querySelectorAll('[data-retire-at]').forEach(el=>{
      const isTrio=el.matches('[data-lbfss-open="trio"]')||/-trio$/i.test(el.id||'');
      const boundary=isTrio?dinnerStartMs():Date.parse(el.dataset.retireAt);
      const retired=time===null||!Number.isFinite(boundary)||time>=boundary;
      el.hidden=retired;
      if(retired){
        el.style.setProperty('display','none','important');
        const root=el.closest('[data-offer-master]');
        root?.querySelectorAll('dialog[id$="-trio"][open]').forEach(d=>d.close());
      }else{
        el.style.removeProperty('display');
      }
    });
    document.querySelectorAll('a[href$="#box-trio"]').forEach(link=>{
      if(!/BEST SELLER TRIO/i.test(link.textContent||''))return;
      link.hidden=retiredTrio;
      link.style.display=retiredTrio?'none':'';
      if(retiredTrio){link.setAttribute('aria-hidden','true');link.tabIndex=-1;}
      else{link.removeAttribute('aria-hidden');link.removeAttribute('tabIndex');}
    });
    if(retiredTrio)document.querySelectorAll('dialog[id$="-trio"][open]').forEach(d=>d.close());
    document.querySelectorAll('lbf-promo-card[data-scheduled]').forEach(el=>el.tick?.());
    if(window.LBF_PROMOS&&typeof window.LBF_PROMOS.refresh==='function')window.LBF_PROMOS.refresh();
  };
  const sync=()=>pending ||= fetch((window.Shopify?.routes?.root||'/')+'cart.js?lbf_clock='+Math.random().toString(36).slice(2),{cache:'no-store',signal:AbortSignal.timeout(8000),headers:{Accept:'application/json'}})
    .then(r=>{const date=Date.parse(r.headers.get('Date'));const age=Number(r.headers.get('Age')||0);if(!r.ok||!Number.isFinite(date)||!Number.isFinite(age)||age>10)throw Error('Fresh server time unavailable');epoch=date+age*1000;at=performance.now();})
    .catch(()=>{epoch=null;}).finally(()=>{pending=null;refreshDinnerStart().finally(apply);});
  window.LBF_OFFER_CLOCK={now,sync,dinnerStartMs,trioRetired,refreshDinnerStart,offerSource};
  sync();setInterval(sync,60000);setInterval(apply,1000);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)sync();});window.addEventListener('pageshow',sync);
  document.addEventListener('click',e=>{const button=e.target.closest('[data-lbfss-open="trio"],[data-lbfss-add="frozen-best-seller-trio"]');if(button&&trioRetired(now())){e.preventDefault();e.stopImmediatePropagation();}},true);
}

/* ============================================================
 * lbf-cart-journey.js  v1.0  (2026-09-26, cart journey redesign)
 * Build spec: command-center/2026-09/20260925_LBF_Cart_Journey_Build_Spec_Ver1.md
 *
 *  LBF_CART    live cart: one request at a time, optimistic numbers, revert on 422,
 *              publish(cartUpdate) + 'cart:update' after every write. Never touches a
 *              line carrying _lbf_box* or _bundle_id (box lines).
 *  LBF_TOAST   the one toast style for every cart event (spec 3.7).
 *  LBF_PROMOS  gift progress read from the BADGE TEXT shoppers see (Carl 2026-09-26):
 *              "ANY N FREE X" = count every paid unit carrying that tag, one X per N;
 *              "BUY N FREE M" = per SKU, M free of the same SKU per N. Anything else is
 *              a badge only and never promises a gift. Cart Bot adds the gift itself.
 *  Collection cards: "Add to cart" becomes  - n +  and every tap writes to the cart.
 *  Dish page tray (snippet lbf-dish-tray): choose quantities, one "Add N to cart".
 *  Frozen minimum reached -> blue toast (the area picker no longer opens itself).
 * ============================================================ */
(function () {
  'use strict';
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };
  if (window.LBF_CART) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FROZEN = 'frozen';
  var SOLO = 'cc_solo_ok';

  function money(c) { return 'RM' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* ---- GA4 tracking helper (Ian, 9 Oct 2026; plan 20261009_Step0_Audit_and_Build_Plan.md) ----
     track() keeps the dataLayer push exactly as before, then ALSO sends the event to GA4 through the page's own
     gtag (installed by the Google & YouTube channel app, same client id/session as add_to_cart and purchase),
     and publishes it to Shopify.analytics so a custom pixel can subscribe later. Every leg is guarded and can
     never throw. send_to keeps lbf_* away from the Ads/Merchant tags. No customer id, email, phone, name or
     address is ever added: only cart_lane and ship_zone context. */
  var GA4_ID = 'G-0E9RWXGE48';
  function cartLane() {
    try {
      var c = window.LBF_CART && window.LBF_CART.get && window.LBF_CART.get();
      var paid = ((c && c.items) || []).filter(function (li) { return li.final_line_price > 0; });
      if (!paid.length) return 'empty';
      var fz = paid.some(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN; });
      var rt = paid.some(function (li) { return String(li.product_type || '').toLowerCase() === 'retort'; });
      return fz && rt ? 'mixed' : (fz ? 'frozen' : 'rte');
    } catch (e) { return 'unknown'; }
  }
  function shipZone() {
    try {
      var S = window.LBF_SHIPPING, r = S && (S.getRegularRegion() || S.getFrozenRegion());
      return r === 'east-msia' ? 'east' : (r ? 'west' : 'unknown');
    } catch (e) { return 'unknown'; }
  }
  function gaParams(data) {
    var p = {};
    Object.keys(data || {}).forEach(function (k) {
      var v = data[k];
      if (k === 'event' || k.indexOf('gtm.') === 0 || v == null) return; /* gtm.* keys are added to the pushed object by gtag.js */
      if (typeof v === 'number' && isFinite(v)) p[k] = v;
      else if (typeof v === 'string' || typeof v === 'boolean') p[k] = String(v).slice(0, 100);
    });
    if (!p.cart_lane) p.cart_lane = cartLane();
    if (!p.ship_zone) p.ship_zone = shipZone();
    return p;
  }
  function analyticsDenied() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var c = cp && cp.currentVisitorConsent && cp.currentVisitorConsent();
      return !!(c && c.analytics === 'no');
    } catch (e) { return false; }
  }
  function sendGA(event, params, retried) {
    try {
      if (analyticsDenied()) return;
      if (typeof window.gtag === 'function') { window.gtag('event', event, Object.assign({ send_to: GA4_ID }, params)); return; }
      if (!retried) setTimeout(function () { sendGA(event, params, true); }, 1500);
    } catch (e) { /* analytics must never break the storefront */ }
  }
  function track(event, data) {
    try { window.dataLayer = window.dataLayer || []; data = data || {}; data.event = event; window.dataLayer.push(data); } catch (e) {}
    try {
      var params = gaParams(data);
      sendGA(event, params);
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(event, params); } catch (e) {}
    } catch (e) {}
  }
  /* private cart attribute _lbf_sheet_add = how many Added-sheet adds this cart has had. Read the cart fresh and
     send the MERGED attribute set so _fbp/_fbc/_logged_in/offer markers are never overwritten (GOTCHAS 16, 50).
     Interaction-time only (never on page load); serialised so two quick taps cannot read the same count. */
  var sheetAttrChain = Promise.resolve();
  function bumpSheetAdd() {
    sheetAttrChain = sheetAttrChain.then(function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          var a = Object.assign({}, c.attributes || {});
          a._lbf_sheet_add = String((parseInt(a._lbf_sheet_add, 10) || 0) + 1);
          return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) });
        }).catch(function () {});
    });
  }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function lower(a) { return (a || []).map(function (x) { return String(x).trim().toLowerCase(); }); }
  function isBoxLine(li) {
    var p = li && li.properties;
    if (!p) return false;
    return Object.keys(p).some(function (k) { return k.indexOf('_lbf_box') === 0 || k === '_bundle_id'; });
  }
  function isGiftLine(li) { return li && (li.final_line_price === 0 || /^\[gift\]/i.test(li.product_title || li.title || '')); }
  function shortTitle(t) {
    /* "花生莲藕肉骨汤 Lotus Root & Peanut Stew Soup" -> the English half; "[B3F1] " prefixes dropped. */
    t = String(t || '').replace(/^\[[^\]]*\]\s*/, '');
    /* Carl 2026-09-26: never drop the Chinese name; only the "[B3F1] " style prefix goes */
    return t.trim();
  }

  /* ---------------- product info cache (tags / type / variants) ---------------- */
  var prod = {}, catTags = {};
  var BOOT = window.__LBF_CJ || {};
  Object.keys(BOOT.products || {}).forEach(function (h) { prod[h] = Promise.resolve(BOOT.products[h]); });
  function productInfo(handle) {
    if (!handle) return Promise.resolve(null);
    if (prod[handle]) return prod[handle];
    /* Carl 2026-09-26 bug: a 429 while adding fast used to be cached as "no tags", so that dish never counted
       toward Any 6 / Buy 3 again. A failure is now forgotten and retried; the catalogue fills tags too. */
    var pr = fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (p) { if (p) return p; delete prod[handle]; return catalog().then(function () { var c = catTags[handle]; return c ? { handle: handle, tags: c } : null; }); });
    prod[handle] = pr;
    return pr;
  }

  /* ======================= LBF_TOAST (spec 3.7) ======================= */
  var TOAST_ICON = {
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    gift: '<path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-2-3-5-3-5-1s3 1 5 1c2 0 5 1 5-1s-3-2-5 1"/>',
    snow: '<path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9M9.5 4.5L12 7l2.5-2.5M9.5 19.5L12 17l2.5 2.5"/>',
    alert: '<path d="M12 8v5M12 16.5v.5M10.3 4.2L2.8 17.5A2 2 0 0 0 4.5 20.5h15a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z"/>'
  };
  var TILE = { green: '#2D8A2D', blue: '#61B1E6', red: '#B5122B', dark: '#2C2218' };
  var toastEl = null, toastTimer = null, toastQueue = [], toastBusy = false;
  function bottomOffset() {
    var h = 0;
    ['#lbf-collection-bar.is-shown', '.lbf-cj-footer', '.lbf-sheet.is-open .lbf-sheet__foot'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.height && r.top < window.innerHeight) h = Math.max(h, window.innerHeight - r.top);
    });
    return h + 12;
  }
  function toastNode() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'lbf-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.innerHTML = '<span class="lbf-toast__tile" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></svg></span>' +
      '<span class="lbf-toast__copy"><strong class="lbf-toast__t"></strong><span class="lbf-toast__s"></span></span>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function playToast() {
    var o = toastQueue.shift();
    if (!o) { toastBusy = false; return; }
    toastBusy = true;
    var el = toastNode();
    el.querySelector('.lbf-toast__tile').style.background = TILE[o.tile] || TILE.green;
    el.querySelector('svg').innerHTML = TOAST_ICON[o.icon] || TOAST_ICON.check;
    el.querySelector('.lbf-toast__t').textContent = o.title || '';
    el.querySelector('.lbf-toast__s').textContent = o.sub || '';
    el.style.bottom = bottomOffset() + 'px';
    el.classList.remove('is-on');
    void el.offsetWidth;
    el.classList.add('is-on');
    track('lbf_toast', { kind: o.kind || 'info' });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(playToast, 260);
    }, o.ms || 2600);
  }
  var LBF_TOAST = {
    show: function (o) {
      /* same kind twice in a row collapses into one */
      if (toastQueue.length && toastQueue[toastQueue.length - 1].kind === o.kind) toastQueue.pop();
      toastQueue.push(o);
      if (!toastBusy) playToast();
    }
  };
  window.LBF_TOAST = LBF_TOAST;

  /* ======================= LBF_PROMOS ======================= */
  function badgeRules() {
    if (badgeRules._r) return badgeRules._r;
    var rules = [];
    try {
      var cfg = JSON.parse((document.getElementById('lbf-badge-config') || {}).textContent || '{}');
      (cfg.rules || []).forEach(function (r) {
        var text = String(r.text || '').trim();
        var m = text.match(/^any\s+(\d+)\s+free\s+(?:(\d+)x?\s+)?(.+)$/i);
        var n = text.match(/^buy\s+(\d+)\s+free\s+(\d+)$/i);
        var rule = {
          tag: String(r.tag || '').toLowerCase(), text: text, bg: r.bgColor, fg: r.textColor,
          scheduleMode: r.scheduleMode || 'evergreen', startsAt: r.startsAt || '', endsAt: r.endsAt || ''
        };
        if (m) { rule.kind = 'group'; rule.need = +m[1]; rule.free = +m[2] || 1; rule.gift = (rule.free > 1 ? rule.free + ' ' : '') + titleCase(m[3]); }
        else if (n) { rule.kind = 'sku'; rule.need = +n[1]; rule.free = +n[2]; }
        else rule.kind = 'badge';
        rules.push(rule);
      });
    } catch (e) {}
    badgeRules._r = rules;
    return rules;
  }
  /* benefit lines only (Carl 2026-09-26: "way too lengthy"): the English half of a title, "Instant" dropped.
     Product titles everywhere else keep the Chinese name. */
  function benefitName(t) {
    t = String(t || '').replace(/^\[[^\]]*\]\s*/, '');
    var en = t.replace(/^[\s\S]*[㐀-鿿豈-﫿]\s*/, '') || t;
    return en.replace(/\bInstant\s+/i, '').trim();
  }
  function titleCase(s) { return String(s).toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }); }
  function parseBadgeSchedule(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(value || '').trim());
    if (!match) return NaN;
    var n = match.slice(1).map(Number);
    if (n[1] < 1 || n[1] > 12 || n[2] < 1 || n[2] > 31 || n[3] > 23 || n[4] > 59) return NaN;
    var utc = Date.UTC(n[0], n[1] - 1, n[2], n[3], n[4]);
    var d = new Date(utc);
    if (d.getUTCFullYear() !== n[0] || d.getUTCMonth() !== n[1] - 1 || d.getUTCDate() !== n[2] || d.getUTCHours() !== n[3] || d.getUTCMinutes() !== n[4]) return NaN;
    return utc - 8 * 60 * 60 * 1000;
  }
  function badgeRuleActive(rule) {
    if (!rule.scheduleMode || rule.scheduleMode === 'evergreen') return true;
    if (rule.scheduleMode !== 'scheduled') return false;
    var start = parseBadgeSchedule(rule.startsAt), end = parseBadgeSchedule(rule.endsAt);
    var now = window.LBF_OFFER_CLOCK && window.LBF_OFFER_CLOCK.now();
    return Number.isFinite(start) && Number.isFinite(end) && end > start && Number.isFinite(now) && now >= start && now < end;
  }
  /* Promotion tags only (spec 2): no Best Seller, no FROZEN, no internal labels. */
  var NOT_PROMO = ['bs', 'frozen', 'cc_solo_ok', 'free-gift'];
  function promoBadges(tags) {
    tags = lower(tags);
    return badgeRules().filter(function (r) { return badgeRuleActive(r) && NOT_PROMO.indexOf(r.tag) === -1 && tags.indexOf(r.tag) !== -1; });
  }
  function badgeHTML(tags) {
    return promoBadges(tags).map(function (r) {
      return '<span class="lbf-ptag" style="background:' + esc(r.bg || '#FF7818') + ';color:' + esc(r.fg || '#fff') + '">' + esc(r.text) + '</span>';
    }).join('');
  }
  function noun(lines) {
    var soups = lines.every(function (l) { return /soup/i.test(l.title); });
    return soups ? [lbnT('cart.noun_soup_one', 'soup'), lbnT('cart.noun_soup_other', 'soups')] : [lbnT('cart.noun_dish_one', 'dish'), lbnT('cart.noun_dish_other', 'dishes')];
  }
  /* lines: [{title, qty, tags, variantId}] (paid, non-box). Returns progress + earned. */
  function promoProgress(lines) {
    var out = [];
    badgeRules().forEach(function (r) {
      if (r.kind === 'group') {
        var hit = lines.filter(function (l) { return lower(l.tags).indexOf(r.tag) !== -1; });
        if (!hit.length) return;
        var c = hit.reduce(function (a, l) { return a + l.qty; }, 0);
        var earned = Math.floor(c / r.need), have = c % r.need, rem = r.need - have, w = noun(hit);
        if (earned) out.push({ rule: r, earned: true, qty: earned, text: (earned > 1 ? lbnT('cart.promo_gift_added_many', '{{ n }} × FREE {{ gift }} added', { n: earned, gift: r.gift }) : lbnT('cart.promo_gift_added', 'FREE {{ gift }} added', { gift: r.gift })) });
        if (have || !earned) out.push({ rule: r, earned: false, have: have, need: r.need, rem: rem,
          text: (r.free > 1 ? lbnT('cart.promo_group_progress', 'Add {{ rem }} more {{ noun }}, get FREE {{ gift }}', { rem: rem, noun: (rem === 1 ? w[0] : w[1]), gift: r.gift }) : lbnT('cart.promo_group_progress_one', 'Add {{ rem }} more {{ noun }}, get 1 FREE {{ gift }}', { rem: rem, noun: (rem === 1 ? w[0] : w[1]), gift: r.gift })), count: lbnT('cart.count_of', '{{ have }} of {{ need }}', { have: have, need: r.need }) });
      } else if (r.kind === 'sku') {
        lines.forEach(function (l) {
          if (lower(l.tags).indexOf(r.tag) === -1) return;
          var earned = Math.floor(l.qty / r.need) * r.free, have = l.qty % r.need, rem = r.need - have, nm = benefitName(l.title);
          if (earned) out.push({ rule: r, earned: true, qty: earned, text: lbnT('cart.promo_sku_added', '{{ n }} FREE {{ name }} added', { n: earned, name: nm }) });
          if (have) out.push({ rule: r, earned: false, have: have, need: r.need, rem: rem, variantId: l.variantId,
            text: lbnT('cart.promo_sku_progress', 'Add {{ rem }} more {{ name }} for {{ free }} FREE', { rem: rem, name: nm, free: r.free }), count: lbnT('cart.count_of', '{{ have }} of {{ need }}', { have: have, need: r.need }) });
        });
      }
    });
    return out;
  }
  function refreshPromoBadgeSlots() {
    document.querySelectorAll('[data-lbf-promo-tags]').forEach(function (slot) {
      var tags = [];
      try { tags = JSON.parse(slot.getAttribute('data-lbf-promo-tags') || '[]'); } catch (e) {}
      var html = badgeHTML(tags);
      if (slot.innerHTML !== html) slot.innerHTML = html;
      slot.hidden = !html;
    });
  }
  window.LBF_PROMOS = { rules: badgeRules, badges: promoBadges, badgeHTML: badgeHTML, progress: promoProgress, shortTitle: shortTitle, refresh: refreshPromoBadgeSlots };

  /* ======================= LBF_CART ======================= */
  var cart = BOOT.cart || null, listeners = [], pending = {}, queue = [], running = false, loading = null;
  var cartWaiters = [];
  function cartPending() { return running || queue.length > 0 || Object.keys(timers || {}).length > 0 || Object.keys(pending).length > 0; }
  function settleCartWaiters() {
    if (cartPending()) return;
    cartWaiters.splice(0).forEach(function (resolve) { resolve(cart); });
  }
  function emit(meta) { listeners.forEach(function (f) { try { f(cart, meta || {}); } catch (e) {} }); }
  function plain(c) { return ((c || cart || {}).items || []).filter(function (li) { return li.final_line_price > 0 && !isBoxLine(li); }); }
  function realQty(vid) {
    vid = String(vid);
    return plain().filter(function (li) { return String(li.variant_id) === vid; }).reduce(function (a, li) { return a + li.quantity; }, 0);
  }
  function qtyOf(vid) {
    vid = String(vid);
    if (pending[vid] != null) return pending[vid];
    return realQty(vid);
  }
  function boxQtyOf(vid) {
    return ((cart || {}).items || []).filter(function (li) { return isBoxLine(li) && String(li.variant_id) === String(vid); })
      .reduce(function (a, li) { return a + li.quantity; }, 0);
  }
  var loadSeq = 0, writeSeq = 0, loadedWriteSeq = -1; /* writeSeq: cart writes started; loadedWriteSeq: newest one a finished read already shows */
  function load(fresh, meta) {
    /* fresh: after our own write - never reuse a read that started before it; only the newest read may land */
    if (loading && !fresh) return loading;
    var my = ++loadSeq, seen = writeSeq;
    var p = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (my === loadSeq) { loading = null; if (c) { cart = c; loadedWriteSeq = seen; bubble(); emit(meta); } } return cart; })
      .catch(function () { if (my === loadSeq) loading = null; return cart; });
    loading = p;
    return p;
  }
  var bubbleObs = null;
  function bubble() {
    var a = document.getElementById('cart-icon-bubble');
    if (!a || !cart) return;
    if (!bubbleObs && window.MutationObserver) {
      bubbleObs = new MutationObserver(function () {
        if (!Object.keys(pending).length) return;
        var s = a.querySelector('.cart-count-bubble [aria-hidden]'), want = a.getAttribute('data-lbf-n');
        if (s && want && s.textContent !== want) bubble();
      });
      bubbleObs.observe(a, { childList: true, subtree: true, characterData: true });
    }
    var b = a.querySelector('.cart-count-bubble');
    var n = (cart.item_count || 0);
    Object.keys(pending).forEach(function (v) { n += pending[v] - realQty(v); }); /* taps not yet synced (Carl 2026-09-26: instant like Huel) */
    n = Math.max(0, n);
    var was = +(a.getAttribute('data-lbf-n') || 0);
    a.setAttribute('data-lbf-n', String(n));
    if (!n) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
    b.innerHTML = (n < 100 ? '<span aria-hidden="true">' + n + '</span>' : '') +
      '<span class="visually-hidden">' + esc(lbnT('cart.bubble_items', '{{ n }} items', { n: n })) + '</span>';
    if (n > was) { b.classList.remove('lbf-bump'); void b.offsetWidth; b.classList.add('lbf-bump'); } /* motion v1: count bump */
  }
  function announce(extra) {
    try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, Object.assign({ source: 'lbf-live-cart', cartData: cart }, extra || {})); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'lbf-live-cart' } })); } catch (e) {}
  }
  function post(path, body) {
    writeSeq += 1;
    /* __lbf: our own write - the floating bar already drew it at tap time, so it must not add it again */
    return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), __lbf: 1 })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); });
  }
  function leftFrom(json) {
    var m = String((json && (json.description || json.message)) || '').match(/(\d+)/);
    return m ? m[1] : null;
  }
  function pump() {
    if (running) return;
    var job = queue.shift();
    if (!job) {
      (loadedWriteSeq === writeSeq && !loading ? Promise.resolve(cart) : load()).then(function () {
        if (queue.length || running) return;
        Object.keys(pending).forEach(function (v) { if (!timers[v]) delete pending[v]; });
        bubble(); emit();
        settleCartWaiters();
      });
      return;
    }
    running = true;
    job().then(function () { running = false; pump(); }, function () { running = false; pump(); });
  }
  function enqueue(fn) { queue.push(fn); pump(); }

  /* Carl 2026-09-26 "not crisp like Huel": each tap used to be its own round trip (~0.7s each, one after another),
     so 3 quick taps took ~2.4s to show in the bar and the cart icon. Now a tap is drawn at once everywhere, and
     Shopify gets ONE write per dish, 350ms after the last tap, for the net change. */
  var timers = {};
  function intent(vid, delta) { try { document.dispatchEvent(new CustomEvent('lbf:cart-intent', { detail: { variantId: String(vid), delta: delta } })); } catch (e) {} }
  function synced(vid) { try { document.dispatchEvent(new CustomEvent('lbf:cart-synced', { detail: { variantId: String(vid) } })); } catch (e) {} }
  function syncVariant(vid) {
    var want = pending[vid];
    if (want == null) { synced(vid); return Promise.resolve(); }
    var d = want - realQty(vid);
    if (!d) { synced(vid); return Promise.resolve(); }
    if (d > 0) {
      return post('cart/add.js', { items: [{ id: +vid, quantity: d }] }).then(function (r) {
        if (!r.ok) { delete pending[vid]; var n = leftFrom(r.json); LBF_TOAST.show({ kind: 'stock', tile: 'red', icon: 'alert', title: n ? lbnT('cart.toast_only_left', 'Only {{ n }} left', { n: n }) : lbnT('cart.toast_could_not_add', 'Could not add that'), sub: lbnT('cart.toast_check_before_again', 'Please check your cart before adding again') }); }
        return load(true).then(function () { synced(vid); announce({ variantId: +vid }); return r; });
      });
    }
    var line = plain().filter(function (li) { return String(li.variant_id) === vid; }).sort(function (a, b) { return b.quantity - a.quantity; })[0];
    if (!line) { delete pending[vid]; synced(vid); return Promise.resolve(); }
    var beforeQty=realQty(vid);
    return post('cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity + d) }).then(function (r) {
      if(!r.ok || !r.json || !Array.isArray(r.json.items)){delete pending[vid];throw Error('Cart update could not be confirmed');}
      cart = r.json; bubble(); emit();
      // A SKU can have offer and ordinary lines. Reconcile the full requested total.
      if(pending[vid] != null && realQty(vid) > pending[vid]) {
        if(realQty(vid)<beforeQty) return syncVariant(vid);
        delete pending[vid];throw Error('Cart update could not be confirmed');
      }
      synced(vid); announce({ variantId: +vid });
    });
  }

  /* Carl 10 Oct: several dishes tapped in a row reached Shopify one round trip each, strictly in turn
     (6 dishes ~5s on wifi, View Cart spun 7-8s on a phone). Every dish ready when a sync starts now goes in
     ONE cart/add.js; a rejected batch (stock) falls back to one request per dish so each keeps its own message. */
  var ready = {}, readyQueued = false, ctxs = {};
  function markReady(vid) {
    ready[vid] = true;
    if (readyQueued) return;
    readyQueued = true;
    enqueue(syncReady);
  }
  function syncOne(vid) {
    var ctx = ctxs[vid];
    return syncVariant(vid).then(function (r) {
      if (r && r.ok && ctx && ctx.onAdded) ctx.onAdded();
    }).catch(function () {
      delete pending[vid];
      return load(true).then(function () { synced(vid); LBF_TOAST.show({ kind: 'stock', tile: 'red', icon: 'alert', title: lbnT('cart.toast_check_cart', 'Please check your cart'), sub: lbnT('cart.toast_update_unconfirmed', 'We could not confirm this update. Check your cart before adding again.') }); });
    }).finally(function () { if (ctx && ctx.onSettled) ctx.onSettled(); });
  }
  function syncReady() {
    readyQueued = false;
    var vids = Object.keys(ready); ready = {};
    var adds = vids.filter(function (vid) { return pending[vid] != null && pending[vid] - realQty(vid) > 0; });
    var others = vids.filter(function (vid) { return adds.indexOf(vid) === -1; });
    var batch = adds.length < 2 ? Promise.resolve(false) : post('cart/add.js', {
      items: adds.map(function (vid) { return { id: +vid, quantity: pending[vid] - realQty(vid) }; })
    }).then(function (r) {
      if (!r.ok) return false;
      return load(true).then(function () {
        adds.forEach(function (vid) {
          var ctx = ctxs[vid];
          synced(vid); announce({ variantId: +vid });
          if (ctx && ctx.onAdded) ctx.onAdded();
          if (ctx && ctx.onSettled) ctx.onSettled();
        });
        return true;
      });
    }, function () { return false; });
    return batch.then(function (done) {
      return (done ? others : adds.concat(others)).reduce(function (p, vid) { return p.then(function () { return syncOne(vid); }); }, Promise.resolve());
    });
  }

  var LBF_CART = {
    get: function () { return cart; },
    isPending: cartPending,
    whenSettled: function () { return cartPending() ? new Promise(function (resolve) { cartWaiters.push(resolve); }) : Promise.resolve(cart); },
    load: load,
    on: function (f) { listeners.push(f); if (cart) f(cart); },
    qty: qtyOf,
    boxQty: boxQtyOf,
    plainLines: plain,
    /* one tap on a stepper: +1 / -1, written to the real cart */
    step: function (vid, dir, ctx) {
      vid = String(vid);
      var before = qtyOf(vid);
      var next = Math.max(0, before + (dir > 0 ? 1 : -1));
      if (next === before) return;
      pending[vid] = next; bubble(); emit(); intent(vid, next - before);
      if (ctx && ctx.event) track(ctx.event, Object.assign({ dir: dir > 0 ? 'plus' : 'minus' }, ctx.data || {}));
      ctxs[vid] = ctx;
      clearTimeout(timers[vid]);
      timers[vid] = setTimeout(function () { delete timers[vid]; markReady(vid); }, 350);
    },
    /* View Cart: send every dish still inside its 350ms pause now. */
    flush: function () { Object.keys(timers).forEach(function (vid) { clearTimeout(timers[vid]); delete timers[vid]; markReady(vid); }); },
    /* one request for several dishes (dish page tray, Add buttons) */
    addItems: function (items, props) {
      return new Promise(function (resolve) {
        enqueue(function () {
          var body = { items: items.map(function (i) { var o = { id: +i.id, quantity: i.quantity }; if (props) o.properties = props; return o; }) };
          return post('cart/add.js', body).then(function (r) {
            if (!r.ok) { var n = leftFrom(r.json); LBF_TOAST.show({ kind: 'stock', tile: 'red', icon: 'alert', title: n ? lbnT('cart.toast_only_left', 'Only {{ n }} left', { n: n }) : lbnT('cart.toast_could_not_add', 'Could not add that'), sub: r.json && r.json.description ? String(r.json.description).slice(0, 80) : lbnT('cart.toast_try_again', 'Please try again') }); }
            /* Resolve only after the shared cart model is current. The drawer keeps
               its loading treatment until this model, its rows and its footer agree. */
            return load(true).then(function () { announce(); resolve(r); });
          }).catch(function () {
            return load(true).then(function () {
              LBF_TOAST.show({ kind: 'stock', tile: 'red', icon: 'alert', title: lbnT('cart.toast_check_cart', 'Please check your cart'), sub: lbnT('cart.add_unconfirmed', 'We could not confirm the add. Check your cart before adding again.') });
              resolve({ ok: false, status: 0 });
            });
          });
        });
      });
    },
    /* optimistic header count, so a tap shows up at once */
    bump: function (n) { if (cart) { cart.item_count = (cart.item_count || 0) + n; bubble(); } },
    setNote: function (note) { return post('cart/update.js', { note: note }); }
  };
  // One loading treatment, without replacing price/label nodes owned by other scripts.
  LBF_CART.setAdding = function (el, busy) {
    if (!el) return;
    if (busy) formAddAt = 0; // This add owns its confirmation, including app-driven gift refreshes.
    if (busy) el.setAttribute('data-lbn-adding', lbnT('cart.adding', 'Adding…')); /* zh-CN 15 Oct 2026: busy overlay text (lbf-cart-journey.css) */
    el.classList.toggle('lbf-add-busy', !!busy);
    if (busy) el.setAttribute('aria-busy', 'true');
    else el.removeAttribute('aria-busy');
  };
  LBF_CART.isGridAdd = function (source) {
    if (!source || !source.closest) return false;
    if (source.closest('#ProductGridContainer')) return true;
    var modal = source.closest('quick-add-modal');
    return !!(modal && modal.openedBy && modal.openedBy.closest('#ProductGridContainer'));
  };
  LBF_CART.confirmAdded = function (handle, source) {
    var inlineGrid = LBF_CART.isGridAdd(source);
    formAddAt = 0;
    return load(true).then(function () {
      var variantId = source && source.getAttribute && source.getAttribute('data-variant-id');
      var addedLine = variantId && (cart.items || []).filter(function (line) { return String(line.variant_id) === String(variantId); })[0];
      if (!inlineGrid) openAddedSheet(handle || (addedLine && addedLine.handle) || '');
    });
  };
  window.LBF_CART = LBF_CART;

  /* Other scripts write to the cart too (Dawn forms, bundle builder, recommendations). */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var tracksDrawerCommit = /\/cart\/(add|change|update|clear)/.test(url) && !(init && init.__lbf);
    if (tracksDrawerCommit) writeSeq += 1;
    if (tracksDrawerCommit && window.LBF_DRAWER) window.LBF_DRAWER.beginCommit();
    var p = _fetch.apply(this, arguments);
    /* Carl 29 Oct: a drawer remove/qty change came back with the new cart AND the redrawn drawer, yet the
       checkout stayed grey ~0.5s more while we re-read cart.js and the drawer section. Dawn's own write
       (it asks for the cart-drawer section) now hands that reply over directly. */
    var dawnDrawerWrite = tracksDrawerCommit && /\/cart\/change/.test(url) && typeof (init && init.body) === 'string' && init.body.indexOf('cart-drawer') !== -1;
    if (dawnDrawerWrite) {
      p.then(function (r) { return r.ok ? r.clone().json() : null; }).then(function (j) {
        if (!j || !Array.isArray(j.items) || !j.sections || !j.sections['cart-drawer']) throw new Error('no cart in reply');
        var c = Object.assign({}, j); delete c.sections;
        loadSeq += 1; loading = null; cart = c; bubble(); emit({ skipDrawerRefresh: true });
        if (window.LBF_DRAWER) window.LBF_DRAWER.markModelReady(c, { dawnDom: true });
      }).catch(function () {
        setTimeout(function () { load(true, { skipDrawerRefresh: true }).then(function (c) { if (window.LBF_DRAWER) window.LBF_DRAWER.markModelReady(c); }); }, 60);
      });
    } else if (tracksDrawerCommit) {
      // Account for app-owned gift writes as well as our own queue. The final
      // read schedules one complete drawer refresh after these writes settle.
      p.then(function () {
        setTimeout(function () {
          load(true, { skipDrawerRefresh: true }).then(function (c) {
            if (window.LBF_DRAWER) window.LBF_DRAWER.markModelReady(c);
          });
        }, 60);
      }).catch(function () { if (window.LBF_DRAWER) window.LBF_DRAWER.abortCommit(); });
    }
    return p;
  };

  /* ---------------- frozen minimum reached -> toast (spec 3.5) ---------------- */
  var fzPrev = null, soloCache = {};
  function frozenCount(c) {
    return plain(c).filter(function (li) {
      return String(li.product_type || '').toLowerCase() === FROZEN && !soloCache[li.handle];
    }).reduce(function (a, li) { return a + li.quantity; }, 0);
  }
  LBF_CART.on(function (c) {
    if (!c) return;
    var handles = plain(c).filter(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN && !(li.handle in soloCache); }).map(function (li) { return li.handle; });
    Promise.all(handles.map(function (h) { return productInfo(h).then(function (p) { soloCache[h] = !!(p && lower(p.tags).indexOf(SOLO) !== -1); }); }))
      .then(function () {
        var n = frozenCount(c);
        if (fzPrev !== null && fzPrev < 3 && n >= 3 && !Object.keys(pending).length) {
          var region = window.LBF_SHIPPING && LBF_SHIPPING.getFrozenRegion && LBF_SHIPPING.getFrozenRegion();
          LBF_TOAST.show({ kind: 'frozen_unlocked', tile: 'blue', icon: 'snow', title: lbnT('ship.toast_frozen_unlocked', 'Cold-chain delivery unlocked'),
            sub: region ? lbnT('ship.toast_frozen_can_ship', 'Your frozen dishes can now ship') : lbnT('ship.toast_tap_choose_area', 'Tap Choose area to see your delivery fee') });
        }
        if (!Object.keys(pending).length) fzPrev = n;
      });
  });

  /* ======================= shared stepper ======================= */
  var MINUS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  function stepperHTML(name, cls) {
    return '<div class="lbf-stp ' + (cls || '') + '">' +
      '<button type="button" class="lbf-stp__m" data-stp="-1" aria-label="' + esc(lbnT('cart.stepper_remove_one_name', 'Remove one {{ name }}', { name: name })) + '">' + MINUS + '</button>' +
      '<span class="lbf-stp__n" aria-live="polite">0</span>' +
      '<button type="button" class="lbf-stp__p" data-stp="1" aria-label="' + esc(lbnT('cart.stepper_add_one_name', 'Add one {{ name }}', { name: name })) + '">' + PLUS + '</button></div>';
  }
  function setStepper(el, n) {
    el.querySelector('.lbf-stp__n').textContent = n;
    el.classList.toggle('is-zero', !n);
  }
  function flash(btn) { btn.classList.remove('is-flash'); void btn.offsetWidth; btn.classList.add('is-flash'); }
  LBF_CART.stepperHTML = stepperHTML;
  LBF_CART.setStepper = setStepper;
  LBF_CART.flash = flash;

  /* ======================= collection cards (spec 3.1) ======================= */
  function enhanceCards(scope) {
    var forms = (scope || document).querySelectorAll('#ProductGridContainer .quick-add product-form form[data-type="add-to-cart-form"]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.__lbf) return;
      var idInput = form.querySelector('input[name="id"]');
      var submit = form.querySelector('.quick-add__submit');
      if (!idInput || !submit || idInput.disabled || submit.disabled) return;
      form.__lbf = true;
      var vid = String(idInput.value);
      var card = form.closest('.card-wrapper, .card, li') || form;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link ? (link.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1] : '';
      var titleEl = card.querySelector('.lbf-card-title, .card__heading');
      var name = titleEl ? titleEl.textContent.trim() : lbnT('cart.card_name_fallback', 'dish');
      var wrap = document.createElement('div');
      wrap.className = 'lbf-card-stp';
      wrap.innerHTML = stepperHTML(name, 'lbf-stp--card');
      form.appendChild(wrap);
      var stp = wrap.firstChild;
      function paint() {
        var n = qtyOf(vid);
        setStepper(stp, n);
        form.classList.toggle('lbf-has-qty', n > 0);
      }
      LBF_CART.on(paint);
      form.addEventListener('submit', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (qtyOf(vid) > 0) return; // The first tap already switched this card to its stepper.
        formAddAt = 0; // Inline quantity is the confirmation; do not open a cart overlay.
        LBF_CART.step(vid, 1, { event: 'lbf_card_step', data: { product: handle } });
        form.classList.add('lbf-has-qty');
        var plus = stp.querySelector('.lbf-stp__p'); if (plus) flash(plus); /* motion v1 */
      }, true);
      stp.addEventListener('click', function (e) {
        var b = e.target.closest('[data-stp]');
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        formAddAt = 0;
        var d = +b.getAttribute('data-stp');
        flash(b); /* motion v1: flash the tapped + or - */
        LBF_CART.step(vid, d, { event: 'lbf_card_step', data: { product: handle } });
      });
      paint();
    });
  }
  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    enhanceCards(grid);
    new MutationObserver(function () { enhanceCards(grid); }).observe(grid, { childList: true, subtree: true });
  }

  /* ======================= dish page tray (spec 3.2) ======================= */
  function isSoup(t) { return /soup|汤/i.test(t || ''); }
  function kindOf(p) { return String(p.type || p.product_type || '').toLowerCase() === FROZEN ? 'frozen' : 'rte'; }
  function variantOf(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return null;
  }
  function pickRowHTML(p, v, pos) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var sized = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (img.indexOf('?') > -1 ? '&' : '?') + 'width=128' : '';
    var cmp = v.compare_at_price && v.compare_at_price > v.price ? '<s class="lbf-tray__srp">' + money(v.compare_at_price) + '</s>' : '';
    var tags = badgeHTML(p.tags);
    return '<div class="lbf-tray__row" data-variant-id="' + v.id + '" data-price="' + v.price + '" data-handle="' + esc(p.handle) + '" data-pos="' + pos + '">' +
      '<a class="lbf-tray__img" href="' + ROOT + 'products/' + esc(p.handle) + '" tabindex="-1" aria-hidden="true">' + (sized ? '<img src="' + esc(sized) + '" alt="" width="56" height="56" loading="eager" decoding="async">' : '') + '</a>' +
      '<div class="lbf-tray__body"><a class="lbf-tray__name" href="' + ROOT + 'products/' + esc(p.handle) + '">' + esc(shortTitle(p.title)) + '</a>' +
      (tags ? '<div class="lbf-tray__tags">' + tags + '</div>' : '') +
      '<div class="lbf-tray__line"><span class="lbf-tray__price">' + cmp + '<span>' + money(v.price) + '</span></span>' + stepperHTML(shortTitle(p.title), 'lbf-stp--tray') + '</div></div></div>';
  }
  /* A tray lives on the dish page AND inside Dawn's "Choose options" pop-up on collection pages
     (quick-add-modal loads the dish page's product-info). Each one is started on its own. */
  /* Editable offer records come from the canonical All Meals card board.
     Absent/disabled/expired records produce no PDP offer. No discount admin action occurs here. */
  function offerActive(o) {
    var now = o.kind === "dinner" && (o.start || o.end) ? window.LBF_OFFER_CLOCK.now() : Date.now();
    if(now === null)return false;
    return !!o.enabled && (!o.start || Number.isFinite(Date.parse(o.start)) && now >= Date.parse(o.start)) && (!o.end || Number.isFinite(Date.parse(o.end)) && now < Date.parse(o.end));
  }
  function sharkPaidMaximum(offer) {
    var paid=offer.inventoryManaged&&offer.inventoryPolicy==='deny'?Math.max(0,Math.floor((Number(offer.inventoryQuantity||0)-qtyOf(offer.variant))/5)*5):Infinity;
    var gifts=offer.giftInventoryManaged&&offer.giftInventoryPolicy==='deny'?Math.max(0,Number(offer.giftInventoryQuantity||0)-qtyOf(offer.giftVariant))*5:Infinity;
    return Math.min(paid,gifts);
  }
  /* Offer records: one shared, cached source (see LBF_OFFER_CLOCK.offerSource at the top of this file). */
  function sharedOffers(fresh) {
    return window.LBF_OFFER_CLOCK.offerSource(!!fresh)
      .then(function(src){return src.records.filter(function(o){return o.kind==='dinner'||offerActive(o);});})
      .catch(function(){return [];});
  }
  function installSharedOffer(tray, offer) {
    var row=tray.querySelector('[data-this]'), add=tray.querySelector('.lbf-tray__add');
    if (!row || !add || tray.querySelector('.lbf-opt')) return;
    var oldLabel=tray.querySelector('.lbf-tray__label');if(oldLabel)oldLabel.remove();
    var heading=document.createElement('h2');heading.className='lbf-tray__choice-title';heading.textContent=offer.kind==='shark'?lbnT('product.tray_this_dish_heading','THIS DISH'):lbnT('product.tray_choose_option','Choose your option');tray.insertBefore(heading,row);
    var single=document.createElement('div');single.className='lbf-opt';single.setAttribute('data-opt','single');
    single.innerHTML='<label class="lbf-opt__head"><input type="radio" name="lbf-mode-'+esc(tray.dataset.productId)+'" value="single"><span class="lbf-opt__heading"><span class="lbf-opt__t">'+(offer.kind==='shark'?esc(lbnT('product.tray_single_pack_price','Single pack · {{ price }}',{price:money(offer.price)})):esc(lbnT('product.tray_this_dish_only','This dish only')))+'</span><span class="lbf-opt__meta" data-single-summary>'+money(offer.price)+'</span></span></label>';
    tray.insertBefore(single,row);single.appendChild(row);
    var box=document.createElement('div');box.className='lbf-opt is-on';box.setAttribute('data-opt','box');
    box.innerHTML='<div class="lbf-opt__strap">'+esc(offer.kind==='shark'?lbnT('offer.strap_most_popular','MOST POPULAR'):offer.kind==='rendang'?lbnT('offer.strap_flash_price','FLASH PRICE'):offer.kind==='starter'?lbnT('offer.strap_most_popular','MOST POPULAR'):lbnT('offer.strap_multipack','MULTIPACK OFFER'))+'</div>'+ // Existing strap styling and approved offer wording.
      '<label class="lbf-opt__head"><input type="radio" name="lbf-mode-'+esc(tray.dataset.productId)+'" value="box" checked><span class="lbf-opt__heading"><span class="lbf-opt__t">'+esc(offer.kind==='shark'?lbnT('offer.shark_buy5_get1','Buy 5, Get 1 Free'):offer.title)+'</span><span class="lbf-opt__meta" data-box-summary></span></span></label>'+
      '<div class="lbf-box__rows"><div class="lbf-box__row" data-box-variant="'+offer.variant+'" data-price="'+offer.price+'" data-compare="'+(offer.compare||0)+'" data-handle="'+esc(offer.handle)+'" data-box-this>'+
      '<span class="lbf-box__img" aria-hidden="true"><img src="'+esc(offer.image)+'" width="44" height="44" alt=""></span><span class="lbf-box__b"><span class="lbf-box__n">'+esc(offer.productTitle)+'</span><span class="lbf-box__p">'+(offer.compare>offer.price?'<s>'+money(offer.compare)+'</s> ':'')+money(offer.price)+'</span></span>'+
      '<span class="lbf-stp lbf-stp--tray"><button type="button" class="lbf-stp__m" data-box-stp="'+((offer.kind==='feet'||offer.kind==='shark')?-5:-1)+'" aria-label="'+esc((offer.kind==='feet'||offer.kind==='shark')?lbnT('product.box_remove_five_paid','Remove five paid packs'):lbnT('product.box_remove_one','Remove one'))+'">−</button><span class="lbf-stp__n" aria-live="polite">'+offer.quantity+'</span><button type="button" class="lbf-stp__p" data-box-stp="'+((offer.kind==='feet'||offer.kind==='shark')?5:1)+'" aria-label="'+esc((offer.kind==='feet'||offer.kind==='shark')?lbnT('product.box_add_five_paid','Add five paid packs'):lbnT('product.box_add_one','Add one'))+'">+</button></span></div></div><p class="lbf-box__save" data-box-save hidden></p>';
    if(offer.kind==='dinner'||offer.kind==='starter'){
      box.querySelector('.lbf-box__rows').innerHTML=offer.items.map(function(item){return '<div class="lbf-box__row" data-box-variant="'+item.id+'" data-price="'+item.price+'" data-compare="'+(item.compare||0)+'" data-handle="'+esc(item.handle)+'"><span class="lbf-box__img"><img src="'+esc(item.image)+'" width="44" height="44" alt=""></span><span class="lbf-box__b"><span class="lbf-box__n">'+esc(item.title)+'</span><span class="lbf-box__p"><strong>'+money(item.selling)+'</strong>'+(item.compare>item.selling?' <s>'+money(item.compare)+'</s>':'')+'</span></span>'+(offer.kind==='starter'?'<span class="lbf-stp lbf-stp--tray"><button type="button" class="lbf-stp__m" data-box-stp="-1" aria-label="'+esc(lbnT('cart.stepper_remove_one_name','Remove one {{ name }}',{name:item.title}))+'">−</button><span class="lbf-stp__n" aria-live="polite">1</span><button type="button" class="lbf-stp__p" data-box-stp="1" aria-label="'+esc(lbnT('cart.stepper_add_one_name','Add one {{ name }}',{name:item.title}))+'">+</button></span>':'<span data-dinner-item-qty>1×</span>')+'</div>';}).join('');
      if(offer.kind==='dinner')box.querySelector('.lbf-box__rows').insertAdjacentHTML('afterend','<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin:12px 0"><span>'+esc(lbnT('product.dinner_sets','Sets'))+'</span><span class="lbf-stp lbf-stp--tray"><button type="button" class="lbf-stp__m" data-dinner-step="-1" aria-label="'+esc(lbnT('product.dinner_remove_set','Remove one set'))+'">−</button><span class="lbf-stp__n" data-dinner-sets aria-live="polite">1</span><button type="button" class="lbf-stp__p" data-dinner-step="1" aria-label="'+esc(lbnT('product.dinner_add_set','Add one set'))+'">+</button></span></div>');
      box.hidden=!offerActive(offer);
    }
    if(offer.kind==='shark'){
      box.querySelector('.lbf-box__n').textContent=lbnT('offer.shark_fin_name','Premium Shark Fin Soup');
      box.querySelector('.lbf-box__rows').insertAdjacentHTML('afterend','<div class="lbf-box__giftrow" data-box-giftrow><span class="lbf-box__img" aria-hidden="true"><img src="'+esc(offer.image)+'" width="44" height="44" alt=""></span><span class="lbf-box__b"><span class="lbf-box__n">'+esc(lbnT('offer.shark_fin_name','Premium Shark Fin Soup'))+'</span><span class="lbf-box__p"><s>'+money(offer.price)+'</s></span></span><span class="lbf-box__free"><span class="lbf-box__fq" data-box-giftqty>1×</span><strong>'+esc(lbnT('offer.gift_free_label','FREE'))+'</strong></span></div>');
      var shipping=document.createElement('a');shipping.className='lbf-tray__alt';shipping.href=ROOT+'policies/shipping-policy';shipping.textContent=lbnT('product.view_shipping_delivery','View shipping & delivery');add.after(shipping);
    }
    tray.insertBefore(box,add);tray.setAttribute('data-box-type','offer');tray.setAttribute('data-box-tag',offer.key);tray.__sharedOffer=offer;tray.__dinnerRecipe=JSON.stringify((offer.items||[]).map(function(i){return [String(i.id),i.price,i.quantity,i.selling];}));
  }

  /* Overlap rule (Carl 2026-10-07): an ACTIVE time-limited offer (e.g. the 10.10 Dinner Box) beats the evergreen set
     (kind 'starter'); the evergreen set never shows on a dish held by its own markdown (data-promo-hold). */
  var EVERGREEN_KINDS=['starter'];
  function pickSharedOffer(tray,offers){
    var h=tray.getAttribute('data-handle');
    var hits=offers.filter(function(o){return o.handle===h||(o.items||[]).some(function(i){return i.handle===h;});});
    var timed=hits.filter(function(o){return EVERGREEN_KINDS.indexOf(o.kind)===-1;});
    var live=timed.filter(offerActive)[0];if(live)return live;
    var evergreen=hits.filter(function(o){return EVERGREEN_KINDS.indexOf(o.kind)!==-1&&offerActive(o);})[0];
    if(evergreen&&tray.getAttribute('data-promo-hold')!=='true')return evergreen;
    return timed[0]||null;
  }
  function initTrays() { Array.prototype.forEach.call(document.querySelectorAll('.lbf-tray'), initTray); }
  function initTray(tray) {
    if (!tray || tray.__lbf) return;
    if (!tray.__offerResolved && ['premium-shark-fin-soup','rendang-pork-belly','teochew-braised-chicken-feet','dry-curry-pork','dry-pork-belly-bak-kut-teh','steam-clam-with-glass-noodle','teochew-braised-pork','bak-kut-teh-soup','sarawak-white-pepper-pig-stomach-soup'].indexOf(tray.getAttribute('data-handle')) !== -1) {
      if (tray.__offerLoading) return;
      tray.__offerLoading = true;
      /* A slow /collections/all must not leave the dish page without a working button: after 2.5 s start plain. */
      Promise.race([sharedOffers(),new Promise(function(r){setTimeout(function(){r([]);},2500);})]).then(function(offers){if(tray.__offerResolved)return;var offer=pickSharedOffer(tray,offers);if(offer)installSharedOffer(tray,offer);tray.__offerResolved=true;initTray(tray);});
      return;
    }
    tray.__lbf = true;
    var modal = tray.closest('quick-add-modal');
    var scope = tray.closest('product-info, .product__info-container, .quick-add-modal__content-info') || document;
    if (!modal) document.documentElement.classList.add('lbf-tray-on');
    var addBtn = tray.querySelector('.lbf-tray__add');
    var picksEl = tray.querySelector('.lbf-tray__picks') || document.createElement('div');
    var productId = tray.getAttribute('data-product-id');
    var handle = tray.getAttribute('data-handle');
    var thisKind = tray.getAttribute('data-kind');
    var thisTitle = tray.getAttribute('data-title');
    var sel = {}; /* variantId -> chosen qty */
    var main = tray.querySelector('.lbf-tray__row[data-this]');
    var mainSoldOut = addBtn.disabled;
    if (!modal) { var pf = function () { catalog(); }; if ('requestIdleCallback' in window) requestIdleCallback(pf, { timeout: 3000 }); else setTimeout(pf, 1500); }
    sel[main.getAttribute('data-variant-id')] = mainSoldOut ? 0 : 1;

    /* this dish: tags + variant dropdown drives the hidden native picker */
    var mainName = main.querySelector('.lbf-tray__name');
    if (mainName) mainName.textContent = shortTitle(mainName.textContent); /* same English name format as the picks */
    var mainTags = [];
    try { mainTags = JSON.parse(tray.getAttribute('data-tags') || '[]'); } catch (e) {}
    var tagSlot = main.querySelector('.lbf-tray__tags');
    if (tagSlot) {
      tagSlot.setAttribute('data-lbf-promo-tags', JSON.stringify(mainTags));
      refreshPromoBadgeSlots();
    }
    var vSel = main.querySelector('.lbf-tray__variant');
    /* "You save" = per-pack saving x packs chosen (Carl 2026-10-15); per pack while nothing is chosen */
    var trSave = main.querySelector('[data-tray-save]');
    var packSave = trSave && !trSave.hidden ? Math.round(parseFloat(trSave.textContent.replace(/[^\d.]/g, '')) * 100) || 0 : 0;
    function paintSave() {
      if (!trSave) return;
      trSave.hidden = !(packSave > 0);
      if (packSave > 0) trSave.textContent = lbnT('product.tray_you_save', 'You save {{ amount }}', { amount: money(packSave * Math.max(1, sel[main.getAttribute('data-variant-id')] || 0)) });
    }
    function applyVariant(syncNative) {
      if (!vSel || vSel.value === main.getAttribute('data-variant-id')) return;
      var opt = vSel.options[vSel.selectedIndex];
      var old = main.getAttribute('data-variant-id');
      var q = sel[old] || 0; delete sel[old];
      main.setAttribute('data-variant-id', vSel.value);
      main.setAttribute('data-price', opt.getAttribute('data-price'));
      sel[vSel.value] = q;
      setTimeout(paintInCart, 0);
      var cmpC = +opt.getAttribute('data-compare') || 0, pr = +opt.getAttribute('data-price');
      main.querySelector('.lbf-tray__price').innerHTML = (cmpC > pr ? '<s class="lbf-tray__srp">' + money(cmpC) + '</s>' : '') + '<span>' + money(pr) + '</span>';
      packSave = cmpC > pr ? cmpC - pr : 0;
      paintSave();
      /* keep Dawn's picker (price block, media, URL) in step - dropdown or pill buttons (Basmathi uses pills) */
      var val = opt.getAttribute('data-option1');
      var native = syncNative && scope.querySelector('variant-selects select');
      if (native) {
        for (var i = 0; i < native.options.length; i++) if (native.options[i].value === val || native.options[i].text.trim() === val) { native.selectedIndex = i; break; }
        native.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (syncNative) {
        var pill = Array.prototype.find.call(scope.querySelectorAll('variant-selects input[type="radio"]'), function (r) { return r.value === val; });
        if (pill && !pill.checked) { pill.checked = true; pill.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      paint();
    }
    if (vSel) vSel.addEventListener('change', function () { applyVariant(true); });
    /* QA 2026-09-26: a pop-up can show a moment before this runs - a variant picked in that moment must still count */
    setTimeout(function () { applyVariant(true); }, 0); /* after the rest of this tray is set up */

    var inCartEl = main.querySelector('.lbf-tray__incart');
    function paintInCart() {
      if (!inCartEl) return;
      var q = qtyOf(main.getAttribute('data-variant-id'));
      inCartEl.hidden = !q;
      inCartEl.textContent = q ? lbnT('product.tray_in_cart', '✓ {{ n }} in your cart', { n: q }) : '';
    }
    LBF_CART.on(paintInCart);
    var deal = tray.querySelector('.lbf-tray__deal');
    if (deal) deal.addEventListener('click', function () { track('lbf_pdp_deal_click', { pdp: handle, box: deal.getAttribute('data-deal') }); });
    function rows() { return tray.querySelectorAll('.lbf-tray__row[data-variant-id]'); }

    /* ---- boxes on the dish page (Carl 2026-09-26): pre-set to the promo minimum, customise, never below it ----
       group = pick any N of the promo dishes (N + gift from the badge wording)
       trio  = the Best Seller Trio's 3 dishes, 1 or more of each
       sku   = Buy N Free 1 on this dish: N or more of it, the free one is the same dish */
    var boxType = tray.getAttribute('data-box-type');
    var boxTag = tray.getAttribute('data-box-tag');
    var mode = 'single', box = null;
    if (boxType) {
      box = { type: boxType, rows: tray.querySelectorAll('.lbf-box__row'), sel: {}, need: 0, free: 1, gift: '' };
      if (boxType === 'group') {
        var giftFree = +tray.getAttribute('data-box-free') || 1;
        var rule = badgeRules().filter(function (r) { return r.tag === boxTag && r.kind === 'group'; })[0] || { need: 6, free: giftFree, gift: (giftFree > 1 ? giftFree + ' ' : '') + (tray.getAttribute('data-box-gift') || lbnT('offer.gift_fallback', 'gift')) };
        box.need = rule.need; box.gift = rule.gift; box.free = rule.free || giftFree;
        var names = Array.prototype.map.call(box.rows, function (r) { return r.querySelector('.lbf-box__n').textContent; });
        var noun = names.length && names.every(function (x) { return /soup/i.test(x); }) ? 'soups' : 'dishes';
        tray.querySelector('.lbf-opt[data-opt=box] .lbf-opt__t').textContent = (noun === 'soups' ? lbnT('offer.group_title_soups', 'Any {{ n }} Soups Free {{ gift }}', { n: box.need, gift: box.gift }) : lbnT('offer.group_title_dishes', 'Any {{ n }} Dishes Free {{ gift }}', { n: box.need, gift: box.gift })); /* the badge's promo, title case */
      } else if (boxType === 'offer') {
        box.need = tray.__sharedOffer.quantity; box.free = 0;
      } else if (boxType === 'sku') {
        box.need = +tray.getAttribute('data-box-need') || 3; box.free = +tray.getAttribute('data-box-free') || 1;
      } else {
        box.need = box.rows.length;
      }
      var resetBox = function () {
        box.sel = {};box.sets=1;
        var list = Array.prototype.slice.call(box.rows);
        if (box.type === 'trio') { list.forEach(function (r) { box.sel[r.getAttribute('data-box-variant')] = 1; }); return; }
        for (var i = 0; i < box.need; i++) { var r = list[i % list.length]; var v = r.getAttribute('data-box-variant'); box.sel[v] = (box.sel[v] || 0) + 1; }
      };
      resetBox();
      mode = modal && !mainSoldOut ? 'single' : 'box'; /* PDPs lead with the eligible promotion; quick-add keeps its existing default. */
      Array.prototype.forEach.call(tray.querySelectorAll('.lbf-opt'), function (option) {
        var head = option.querySelector('.lbf-opt__head');
        var panel = document.createElement('div'), clip = document.createElement('div'), content = document.createElement('div');
        panel.className = 'lbf-opt__body'; clip.className = 'lbf-opt__content'; content.className = 'lbf-opt__content-inner';
        panel.id = 'lbf-option-' + Math.random().toString(36).slice(2);
        Array.prototype.slice.call(option.children).forEach(function (child) { if (child !== head && !child.classList.contains('lbf-opt__strap')) content.appendChild(child); });
        clip.appendChild(content); panel.appendChild(clip); option.appendChild(panel);
        var radio = head && head.querySelector('input');
        if (radio) radio.setAttribute('aria-controls', panel.id);
      });
      var setMode = function (m) {
        mode = m;
        Array.prototype.forEach.call(tray.querySelectorAll('.lbf-opt'), function (o) {
          var active = o.getAttribute('data-opt') === m;
          o.classList.toggle('is-on', active);
          var panel = o.querySelector('.lbf-opt__body');
          if (panel) { panel.inert = !active; panel.setAttribute('aria-hidden', String(!active)); }
        });
        var ri = tray.querySelector('.lbf-opt input[value="' + m + '"]'); if (ri) ri.checked = true;
        paint();
      };
      Array.prototype.forEach.call(tray.querySelectorAll('.lbf-opt input'), function (i) { i.addEventListener('change', function () { setMode(i.value); }); });
      tray.addEventListener('click', function (e) {
        var setButton=e.target.closest('[data-dinner-step]');
        if(setButton){e.preventDefault();if(addBtn.classList.contains('lbf-add-busy')||!offerActive(tray.__sharedOffer))return;box.sets=Math.max(1,box.sets+Number(setButton.dataset.dinnerStep));Array.prototype.forEach.call(box.rows,function(r){box.sel[r.getAttribute('data-box-variant')]=box.sets;});paint();return;}
        var b = e.target.closest('[data-box-stp]');
        if (!b) return;
        e.preventDefault();
        var r = b.closest('.lbf-box__row'), v = r.getAttribute('data-box-variant'), d = +b.getAttribute('data-box-stp');
        if (d < 0 && atMin(v)) return; /* the promo minimum holds */
        if(box.type==='offer'&&tray.__sharedOffer.kind==='shark'){
          if(addBtn.classList.contains('lbf-add-busy'))return;
          var next=Math.max(5,(box.sel[v]||5)+d);if(next>sharkPaidMaximum(tray.__sharedOffer))return;
          box.sel[v]=next;if(mode!=='box')setMode('box');else paint();return;
        }
        if (box.type === 'offer' && tray.__sharedOffer.kind === 'feet') {
          box.sel[v] = Math.max(5, Math.min(40, (box.sel[v] || 5) + d));
          if (mode !== 'box') setMode('box'); else paint();
          return;
        }
        box.sel[v] = Math.max(0, (box.sel[v] || 0) + d);
        flash(b);
        if (mode !== 'box') setMode('box'); else paint();
      });
      tray.__box = { reset: resetBox };
      setMode(mode);
      if(box.type==='trio'||(box.type==='offer'&&(tray.__sharedOffer.kind==='dinner'||tray.__sharedOffer.kind==='shark'))){
        var allowedBefore=null;
        var lifecycle=function(){
          var time=window.LBF_OFFER_CLOCK.now();
          var allowed=box.type==='trio'?!(window.LBF_OFFER_CLOCK.trioRetired?window.LBF_OFFER_CLOCK.trioRetired(time):(time===null||time>=Date.parse('2026-10-01T00:00:00+08:00'))):offerActive(tray.__sharedOffer);
          var option=tray.querySelector('[data-opt="box"]');if(option){option.hidden=!allowed;option.style.display=allowed?'':'none';}
          if(!allowed&&mode==='box')setMode('single');
          if(allowed&&allowedBefore===false&&box.type==='offer')setMode('box');
          allowedBefore=allowed;
        };
        lifecycle();setInterval(lifecycle,1000);
        if(box.type==='offer')setInterval(function(){sharedOffers().then(function(offers){var fresh=offers.find(function(o){return o.key===tray.__sharedOffer.key;});tray.__sharedOffer=fresh||Object.assign({},tray.__sharedOffer,{enabled:false});lifecycle();});},30000);
      }
    }
    function boxCount() { var n = 0; Object.keys(box.sel).forEach(function (k) { n += box.sel[k]; }); return n; }
    function atMin(v) { return box.type === 'trio' ? (box.sel[v] || 0) <= 1 : boxCount() <= box.need; }
    function boxPaint() {
      var n = 0, sum = 0, srp = 0;
      Array.prototype.forEach.call(box.rows, function (r) {
        var vid = r.getAttribute('data-box-variant');
        var q = box.sel[vid] || 0;
        var st = r.querySelector('.lbf-stp');
        if (st) { setStepper(st, q); st.classList.toggle('at-min', atMin(vid)); }
        var pr = +r.getAttribute('data-price') || 0, cp = +r.getAttribute('data-compare') || 0;
        n += q; sum += q * pr; srp += q * Math.max(pr, cp);
      });
      /* no "N in your box" counter any more (Carl 2026-09-26): the box never goes below the promo minimum */
      var gq = tray.querySelector('[data-box-giftqty]');
      if (gq) gq.textContent = Math.max(1, Math.floor(n / box.need) * box.free) + '×';
      var summary = tray.querySelector('[data-box-summary]');
      if (summary) {
        var giftCount = Math.max(1, Math.floor(n / box.need) * box.free);
        summary.textContent = (box.type === 'group' && noun === 'soups' ? (box.type === 'trio' ? lbnT('product.box_sum_soups_bundle', '{{ n }} soups in your bundle', { n: n }) : (giftCount === 1 ? lbnT('product.box_sum_soups_gift_one', '{{ n }} soups + {{ g }} free gift', { n: n, g: giftCount }) : lbnT('product.box_sum_soups_gift_other', '{{ n }} soups + {{ g }} free gifts', { n: n, g: giftCount }))) : (box.type === 'trio' ? lbnT('product.box_sum_dishes_bundle', '{{ n }} dishes in your bundle', { n: n }) : (giftCount === 1 ? lbnT('product.box_sum_dishes_gift_one', '{{ n }} dishes + {{ g }} free gift', { n: n, g: giftCount }) : lbnT('product.box_sum_dishes_gift_other', '{{ n }} dishes + {{ g }} free gifts', { n: n, g: giftCount }))));
      }
      if (box.type === 'offer') {
        var offer = tray.__sharedOffer;
        // Generated from individually audited Shopify rules; never sum non-combinable tiers.
        // This snapshot is not runtime Admin retrieval. Cart/checkout allocation remains authoritative.
        var reduction = (offer.discountSnapshot?.rules || []).reduce(function(best,t){return n>=t.minimum ? Math.max(best,t.amount) : best;},0);
        sum=Math.max(0,sum-reduction);
        if(summary)summary.textContent=lbnT('product.box_sum_packets','{{ n }} packets',{n:n});
        if(offer.kind==='starter'&&summary)summary.innerHTML='<strong>'+money(sum)+'</strong>'+(srp>sum?' <s>'+money(srp)+'</s>':'');
        if(offer.kind==='dinner'){sum=offer.total*box.sets;if(summary)summary.innerHTML='<strong>'+money(sum)+'</strong> <s>'+money(srp)+'</s>';tray.querySelector('[data-dinner-sets]').textContent=box.sets;tray.querySelectorAll('[data-dinner-item-qty]').forEach(function(e){e.textContent=box.sets+'×';});tray.querySelectorAll('[data-dinner-step]').forEach(function(b){b.disabled=addBtn.classList.contains('lbf-add-busy')||Number(b.dataset.dinnerStep)<0&&box.sets===1;}); }
        var offerPrice=tray.querySelector('[data-box-this] .lbf-box__p');
        if(offerPrice&&offer.kind!=='shark')offerPrice.innerHTML=(srp>sum?'<s>'+money(srp)+'</s> ':'')+'<strong>'+money(sum)+'</strong>';
        if(offer.kind==='shark'){
          var maximum=sharkPaidMaximum(offer), minus=tray.querySelector('[data-box-stp="-5"]'),plus=tray.querySelector('[data-box-stp="5"]');
          if(minus)minus.disabled=n<=5||addBtn.classList.contains('lbf-add-busy');if(plus)plus.disabled=n+5>maximum||addBtn.classList.contains('lbf-add-busy');
          if(summary)summary.textContent=(n===5?lbnT('offer.shark_sum_one','{{ n }} paid packs + {{ free }} free pack',{n:n,free:(n/5)}):lbnT('offer.shark_sum_other','{{ n }} paid packs + {{ free }} free packs',{n:n,free:(n/5)}));
          if(gq){gq.hidden=false;gq.textContent=(n/5)+'×';}
        }
        if(offer.kind==='feet'){
          var minus=tray.querySelector('[data-box-stp="-5"]'), plus=tray.querySelector('[data-box-stp="5"]');
          if(minus)minus.disabled=n<=5;
          if(plus)plus.disabled=n>=40;
        }
      }
      var sv = tray.querySelector('[data-box-save]');
      if (sv) { sv.hidden = srp <= sum; sv.textContent = (box.type === 'offer' ? lbnT('product.box_save_offer', 'You save {{ amount }} with this offer', { amount: money(srp - sum) }) : lbnT('product.box_save_trio', 'You save {{ amount }} with the Trio', { amount: money(srp - sum) })); }
      if (mode !== 'box') return false;
      addBtn.disabled = n < box.need || (box.type==='offer'&&tray.__sharedOffer.kind==='shark'&&n>sharkPaidMaximum(tray.__sharedOffer)) || (box.type === 'offer' && (!tray.__sharedOffer.ready || !offerActive(tray.__sharedOffer)));
      addBtn.querySelector('.lbf-tray__add-t').textContent = box.type==='offer'&&tray.__sharedOffer.kind==='shark'?lbnT('product.tray_add_to_cart_price','Add to cart · {{ price }}',{price:money(sum)}):lbnT('product.tray_add_n_to_cart', 'Add {{ n }} to cart • {{ price }}', { n: n, price: money(sum) });
      return true;
    }
    if(tray.__sharedOffer&&tray.__sharedOffer.kind==='shark')LBF_CART.on(function(){if(tray.isConnected)paint();});
    function paint() {
      var singleSummary = tray.querySelector('[data-single-summary]');
      if (singleSummary) singleSummary.textContent = lbnT('product.tray_price_each', '{{ price }} each', { price: money(+main.getAttribute('data-price') || 0) });
      if (box && boxPaint()) return;
      paintSave();
      var n = 0, sum = 0;
      Array.prototype.forEach.call(rows(), function (r) {
        var v = r.getAttribute('data-variant-id'), q = sel[v] || 0;
        var stp = r.querySelector('.lbf-stp');
        if (stp) setStepper(stp, q);
        n += q; sum += q * (+r.getAttribute('data-price') || 0);
      });
      addBtn.disabled = n === 0;
      addBtn.querySelector('.lbf-tray__add-t').textContent = n ? lbnT('product.tray_add_n_to_cart', 'Add {{ n }} to cart • {{ price }}', { n: n, price: money(sum) }) : (mainSoldOut ? lbnT('product.tray_sold_out', 'Sold out') : lbnT('product.tray_choose_dish', 'Choose a dish above')); /* QA 2026-09-26: a sold-out dish says so */
    }
    tray.addEventListener('click', function (e) {
      var b = e.target.closest('[data-stp]');
      if (!b) return;
      e.preventDefault();
      var r = b.closest('.lbf-tray__row');
      var v = r.getAttribute('data-variant-id');
      var d = +b.getAttribute('data-stp');
      if (d > 0 && mainSoldOut && r === main) return;
      sel[v] = Math.max(0, (sel[v] || 0) + d);
      flash(b);
      if (box && mode !== 'single') setMode('single'); else paint();
    });
    addBtn.addEventListener('click', async function () {
      if (addBtn.disabled || addBtn.classList.contains('lbf-add-busy')) return;
      var oldDinnerError=tray.querySelector('[data-dinner-error]');if(oldDinnerError)oldDinnerError.textContent='';
      var inlineGrid = LBF_CART.isGridAdd(addBtn);
      if (box && mode === 'box') {
        var bitems = [], bn = 0;
        Array.prototype.forEach.call(box.rows, function (r) { var q = box.sel[r.getAttribute('data-box-variant')] || 0; if (q) { bitems.push({ id: r.getAttribute('data-box-variant'), quantity: q }); bn += q; } });
        if (bn < box.need) return;
        if(box.type==='offer'&&!offerActive(tray.__sharedOffer))return;
        if(box.type==='trio'&&(window.LBF_OFFER_CLOCK.trioRetired?window.LBF_OFFER_CLOCK.trioRetired(window.LBF_OFFER_CLOCK.now()):(window.LBF_OFFER_CLOCK.now()===null||window.LBF_OFFER_CLOCK.now()>=Date.parse('2026-10-01T00:00:00+08:00'))))return;
        LBF_CART.setAdding(addBtn, true);
        addBtn.disabled = true;
        tray.querySelectorAll('[data-dinner-step]').forEach(function(b){b.disabled=true;});
        if(box.type==='offer'&&(tray.__sharedOffer.kind==='dinner'||tray.__sharedOffer.kind==='starter')){
          try{
            await window.LBF_OFFER_CLOCK.sync();
            var fresh=(await sharedOffers(true)).find(function(o){return o.key===tray.__sharedOffer.key;});
            if(!fresh||!offerActive(fresh)||!fresh.ready)throw Error(lbnT('offer.err_not_available','This offer is not currently available.'));
            if(JSON.stringify(fresh.items.map(function(i){return [String(i.id),i.price,i.quantity,i.selling];}))!==tray.__dinnerRecipe)throw Error(lbnT('offer.err_changed','This offer has changed. Please refresh before adding.'));
            await Promise.all(fresh.items.map(async function(item){var response=await fetch(ROOT+'products/'+item.handle+'.js',{cache:'no-store'});if(!response.ok)throw Error(lbnT('offer.err_check_failed','Unable to check the dishes. Please try again.'));var product=await response.json(),variant=product.variants.find(function(v){return String(v.id)===String(item.id);});if(!variant?.available||variant.price!==item.price)throw Error(lbnT('offer.err_dish_changed','A dish has changed or is unavailable. Please refresh.'));}));
          }catch(error){LBF_CART.setAdding(addBtn,false);paint();var notice=tray.querySelector('[data-dinner-error]');if(!notice){notice=document.createElement('p');notice.dataset.dinnerError='';notice.setAttribute('role','status');addBtn.after(notice);}notice.textContent=error.message;return;}
        }
        if(box.type==='offer'&&tray.__sharedOffer.kind==='shark'){
          try{var freshShark=(await sharedOffers(true)).find(function(o){return o.key===tray.__sharedOffer.key;});
            if(!freshShark||!offerActive(freshShark)||!freshShark.ready||freshShark.price!==1190||bn>sharkPaidMaximum(freshShark))throw Error(lbnT('offer.err_shark_qty','This quantity is unavailable. Please refresh and choose fewer paid packs.'));
            tray.__sharedOffer=freshShark;
          }catch(error){LBF_CART.setAdding(addBtn,false);paint();var errorNotice=tray.querySelector('[data-shark-error]');if(!errorNotice){errorNotice=document.createElement('p');errorNotice.dataset.sharkError='';errorNotice.setAttribute('role','status');addBtn.after(errorNotice);}errorNotice.textContent=error.message;return;}
        }
        var offerProps=box.type==='offer'?{_lbf_offer_key:tray.__sharedOffer.key,_lbf_offer_name:tray.__sharedOffer.track||tray.__sharedOffer.title,_lbf_offer_source:modal?'Product quickview':'Product page',_lbf_offer_mode:'Recommended selection',_lbf_offer_version:'offer-lines-v2'}:undefined;
        LBF_CART.addItems(bitems,offerProps).then(function (res) {
          LBF_CART.setAdding(addBtn, false);
          if (!res.ok) { paint(); if(box.type==='offer'&&(tray.__sharedOffer.kind==='dinner'||tray.__sharedOffer.kind==='starter'||tray.__sharedOffer.kind==='shark')){var notice=tray.querySelector('[data-dinner-error]');if(!notice){notice=document.createElement('p');notice.dataset.dinnerError='';notice.setAttribute('role','status');addBtn.after(notice);}notice.textContent=res.status===0?lbnT('cart.add_unconfirmed','We could not confirm the add. Check your cart before adding again.'):(res.json?.description||lbnT('offer.err_qty_try_again','This quantity is unavailable. Please try again.'));} return; }
          if (modal && modal.hide) { try { modal.hide(); } catch (e) {} }
          track('lbf_pdp_box_add', { pdp: handle, box: boxTag, qty: bn });
          tray.__box.reset();
          paint();
          if (!inlineGrid) openAddedSheet(handle); // addItems already awaits the fresh cart model.
        });
        return;
      }
      applyVariant(false); /* whatever the dropdown shows is what goes in the cart */
      var items = [], picks = [];
      Array.prototype.forEach.call(rows(), function (r) {
        var v = r.getAttribute('data-variant-id'), q = sel[v] || 0;
        if (!q) return;
        items.push({ id: v, quantity: q });
        if (!r.hasAttribute('data-this')) picks.push({ pick: r.getAttribute('data-handle'), position: +r.getAttribute('data-pos'), qty: q });
      });
      if (!items.length) return;
      var n = items.reduce(function (a, i) { return a + i.quantity; }, 0);
      var fzBefore = frozenCount(cart);
      /* Carl 2026-09-26: "3-4 seconds before it's truly added" -> answer the tap at once, correct it only if Shopify refuses */
      var snapshot = JSON.parse(JSON.stringify(sel));
      var fzAfter = fzBefore + (thisKind === 'frozen' ? n : 0);
      var cartHasFrozen = thisKind === 'frozen' || plain().some(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN; });
      /* Carl 2026-09-26: the "Added To Your Cart" sheet after EVERY dish-page add (Huel pattern) */
      var wantSheet = !inlineGrid;
      LBF_CART.setAdding(addBtn, true);
      addBtn.disabled = true;
      LBF_CART.addItems(items).then(function (res) {
        LBF_CART.setAdding(addBtn, false);
        if (!res.ok) { sel = snapshot; paint(); return; }
        if (modal && modal.hide) { try { modal.hide(); } catch (e) {} }
        picks.forEach(function (p) { track('lbf_pair_add', { pdp: handle, pick: p.pick, position: p.position, qty: p.qty, surface: 'pdp' }); });
        Object.keys(sel).forEach(function (k) { sel[k] = 0; });
        sel[main.getAttribute('data-variant-id')] = mainSoldOut ? 0 : 1;
        paint();
        if (wantSheet) openAddedSheet(handle); // Avoid a second cart read before confirmation.
      });
    });

    /* OFTEN ORDERED TOGETHER: Shopify's own related picks (Carl 2026-09-26), same line
       (frozen or ready-to-eat), 2 closest + 1 "make it a meal" (soup <-> non-soup). */
    if (tray.querySelector('.lbf-tray__picks')) fetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&intent=related&limit=10')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return load().then(function () {
          var inCart = {};
          plain().forEach(function (li) { inCart[li.product_id] = 1; });
          var pool = (j.products || []).filter(function (p) {
            var t = lower(p.tags);
            return String(p.id) !== String(productId) && !inCart[p.id] && variantOf(p) &&
              t.indexOf(SOLO) === -1 && t.indexOf('free-gift') === -1 && kindOf(p) === thisKind;
          });
          var soup = isSoup(thisTitle);
          var meal = pool.filter(function (p) { return isSoup(p.title) !== soup; })[0];
          var close = pool.filter(function (p) { return p !== meal; }).slice(0, meal ? 2 : 3);
          var picks = close.concat(meal ? [meal] : []);
          picksEl.innerHTML = picks.map(function (p, i) { return pickRowHTML(p, variantOf(p), i + 1); }).join('');
          var lab = tray.querySelector('.lbf-tray__label--picks'); if (lab) lab.hidden = !picks.length;
          paint();
        });
      }).catch(function () { picksEl.innerHTML = ''; });
    paint();
  }

  /* ======================= benefits, points, cross-sell rail, "Added To Your Cart" sheet ======================= */
  var sheetEl = null, prodTags = {};
  function paidLines(c) { return ((c || cart || {}).items || []).filter(function (li) { return li.final_line_price > 0; }); }
  function withTags(c) {
    var hs = paidLines(c).map(function (li) { return li.handle; }).filter(function (h) { return !(h in prodTags); });
    return Promise.all(hs.map(function (h) {
      if (catTags[h]) { prodTags[h] = catTags[h]; return null; }
      return productInfo(h).then(function (p) { if (p) prodTags[h] = p.tags; }); /* failed: left unset, asked again next paint */
    })).then(function () { return c; });
  }
  function isLogged() { return !!(window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId); }
  function tagLines(c) { return paidLines(c).map(function (li) { return { title: li.product_title, qty: li.quantity, tags: prodTags[li.handle] || [], variantId: li.variant_id, handle: li.handle }; }); }
  /* Benefit rows (Carl 2026-09-26: keep the main ones in view, collapse the rest; points live above the rail).
     In progress first, closest to done first; earned gifts merge into one line. */
  // Presentation only: use the same independent box quotes as the shipping fee.
  function splitDeliveryRows(s) {
    if (!s.splitWarn || ['moq', 'blocked', 'pickstate', 'empty'].indexOf(s.kind) !== -1) return null;
    var q = s.split, rows = [];
    if (!q || !q.quotable) return [{ ok: false, pri: 1, delivery: true, act: 'area', t: lbnT('ship.split_choose_area', 'Choose your area to see delivery fees for both boxes') }];
    var vn = s.voucherNote;
    var boxes = [{ name: lbnT('ship.split_box_seasonal', 'seasonal box'), quote: q.seasonal }, { name: lbnT('ship.split_box_regular', 'regular box'), quote: q.regular }];
    var saved = boxes.reduce(function (sum, b) { return sum + Math.max(0, b.quote.saved || 0); }, 0);
    if (vn) rows.push({ ok: true, rank: 1, delivery: true, t: vn.text });
    else if (q.total === 0) rows.push({ ok: true, rank: 1, delivery: true, t: lbnT('ship.free_delivery_enjoy', 'You enjoy free delivery') });
    else if (saved > 0) rows.push({ ok: true, rank: 1, delivery: true, t: lbnT('ship.split_saved_two_boxes', 'You saved {{ amount }} on delivery across 2 boxes', { amount: money(saved).replace('.00', '') }) });
    if (!(vn && vn.kind === 'free')) boxes.forEach(function (b) {
      var r = b.quote.result || {};
      if (r.kind === 'mixed-progress') rows.push({ ok: false, pri: 1, delivery: true, t: (window.LBF_SHIPPING && LBF_SHIPPING.seasonalNudge && LBF_SHIPPING.seasonalNudge(r)) || lbnT('ship.split_box_add_save', 'Add {{ amount }} to the {{ box }} to save {{ saving }} on delivery', { amount: money(r.remaining), box: b.name, saving: money(r.baseRate - r.floorRate).replace('.00', '') }), pct: r.pct / 100 });
      else if (r.kind === 'progress') rows.push({ ok: false, pri: 1, delivery: true, t: lbnT('ship.split_box_add_free', 'Add {{ amount }} to the {{ box }} for FREE delivery', { amount: money(r.remaining), box: b.name }), pct: r.pct / 100 });
    });
    return rows;
  }
  LBF_CART.splitDeliveryRows = splitDeliveryRows;

  function summaryRowsFor(c) {
    var S = window.LBF_SHIPPING, rows = [], total = c.total_price || 0;
    var hasFrozen = paidLines(c).some(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN; });
    var tdry = S ? S.TDRY : 15000;
    var st = S && { items: (c.items || []).map(function (li) {
      var tg = lower(prodTags[li.handle] || []), ty = String(li.product_type || '').toLowerCase();
      return { handle: li.handle, key: li.key, qty: li.quantity, linePrice: li.final_line_price, variantId: String(li.variant_id),
        frozenType: ty === S.FROZEN_TYPE || tg.indexOf('frozen') !== -1, frozenTag: ty === S.FROZEN_TYPE || S.FROZEN_TAGS.some(function (x) { return tg.indexOf(x) !== -1; }),
        retortType: ty === S.RETORT_TYPE, soloOk: tg.indexOf(S.SOLO_TAG) !== -1, title: li.product_title };
    }), totalPrice: total, voucher: S.voucherFromCart(c) };
    var voucherNote = null;
    if (!hasFrozen) {
      /* the ready-to-eat rows keep their own wording; the core is asked only for the shipping
         voucher line, with the region the drawer footer uses (a line can be cold-chain by tag alone) */
      var tagFrozen = !!st && st.items.some(function (i) { return i.frozenTag; });
      voucherNote = st ? S.compute(st, S.activeRegion(tagFrozen) || (tagFrozen ? null : 'west-msia'), {}).voucherNote : null;
      if (voucherNote) rows.push({ ok: true, rank: 1, t: voucherNote.text, delivery: true });
      else if (total >= tdry) rows.push({ ok: true, rank: 1, t: lbnT('ship.free_delivery_enjoy', 'You enjoy free delivery'), delivery: true });
      if (total < tdry && !(voucherNote && voucherNote.kind === 'free')) rows.push({ ok: false, pri: 1, t: lbnT('ship.more_for_free_delivery', '{{ amount }} more for FREE delivery', { amount: money(tdry - total) }), pct: total / tdry, delivery: true });
    }
    else if (S) {
      /* frozen in the cart: same wording as the floating bar, from the shared shipping core */
      var s = S.compute(st, S.activeRegion(true), {});
      voucherNote = s.voucherNote;
      if (s.kind === 'moq') { var need = S.MOQ - s.have; rows.push({ ok: false, block: true, t: (need > 1 ? lbnT('ship.moq_add_other', 'Add {{ n }} more frozen dishes for cold-chain delivery', { n: need }) : lbnT('ship.moq_add_one', 'Add {{ n }} more frozen dish for cold-chain delivery', { n: need })), count: lbnT('cart.count_of', '{{ have }} of {{ need }}', { have: s.have, need: S.MOQ }), seg: [s.have, S.MOQ], delivery: true }); }
      else if (s.kind === 'pickstate') rows.push({ ok: false, pri: 1, t: lbnT('ship.pick_area_at_cart', 'Choose your area at the cart to see your delivery fee'), delivery: true });
      if (s.kind !== 'moq' && s.kind !== 'blocked') rows.unshift({ ok: true, cold: true,
        t: s.splitWarn ? lbnT('ship.split_ships_two_boxes', 'Your order ships in 2 boxes') : lbnT('ship.cold_chain_note', 'Ships by cold-chain delivery, packed in insulated packaging'),
        sub: s.splitWarn ? lbnT('ship.split_boxes_sub', 'Box 1: Season Exclusive. Box 2: All other dishes.') : '' });
      var splitRows = splitDeliveryRows(s);
      if (splitRows) rows = rows.concat(splitRows);
      else if (s.kind === 'mixed-progress' && !(voucherNote && voucherNote.kind === 'free')) rows.push({ ok: false, pri: 1, t: (S.seasonalNudge && S.seasonalNudge(s)) || (s.tierFree ? lbnT('ship.mixed_add_free', 'Add {{ amount }} for free delivery', { amount: money(s.remaining) }) : lbnT('ship.mixed_add_save', 'Add {{ amount }} to save {{ saving }} on delivery', { amount: money(s.remaining), saving: money(s.tierSaving).replace('.00', '') })), pct: s.pct / 100, delivery: true });
      else if (s.kind === 'mixed-floor' && !voucherNote) rows.push({ ok: true, rank: 1, t: s.rate === 0 ? lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') : lbnT('ship.mixed_saved', 'You saved {{ amount }} on delivery', { amount: money(s.baseRate - s.floorRate).replace('.00', '') }), delivery: true });
      else if (s.kind === 'blocked') rows.push({ ok: false, block: true, t: lbnT('ship.blocked_there_cannot', 'We cannot ship the frozen dishes in your cart there.'), delivery: true });
      if (voucherNote && !splitRows) rows.push({ ok: true, rank: 1, t: voucherNote.text, delivery: true });
    }
    var prog = promoProgress(tagLines(c));
    prog.filter(function (p) { return !p.earned && p.rule.kind === 'group'; }).sort(function (a, b) { return a.rem - b.rem; })
      .forEach(function (p) { rows.push({ ok: false, pri: 2, t: p.text, count: p.count, seg: [p.have, p.need] }); });
    /* Buy 3 Free 1: one short line here; the full "Add 2 more for 1 FREE" sits on the dish's cart line */
    var sku = prog.filter(function (p) { return !p.earned && p.rule.kind === 'sku'; }).sort(function (a, b) { return a.rem - b.rem; })[0];
    if (sku) rows.push({ ok: false, pri: 3, sku: true, t: lbnT('cart.sku_short', 'Buy {{ need }} Free {{ free }}: add {{ rem }} more', { need: sku.rule.need, free: sku.rule.free, rem: sku.rem }), count: sku.count, seg: [sku.have, sku.need] });
    /* every gift earned = ONE short line; the gift lines themselves are in the cart */
    var got = prog.filter(function (p) { return p.earned; });
    var n = got.reduce(function (a, p) { return a + p.qty; }, 0);
    if (got.length === 1 && got[0].rule.kind === 'group' && n === 1) rows.push({ ok: true, rank: 2, t: lbnT('cart.promo_gift_added', 'FREE {{ gift }} added', { gift: got[0].rule.gift }) });
    else if (n) rows.push({ ok: true, rank: 2, t: (n > 1 ? lbnT('cart.gifts_added_many', '{{ n }} FREE gifts added', { n: n }) : lbnT('cart.gift_added_one', 'FREE gift added')) });
    return rows;
  }
  /* Carl 2026-09-26: what they have EARNED comes first and always shows (people keep what they can see they won);
     only ONE thing still to do is shown - the first in the list (callers put blockers, then delivery, then the closest
     gift first) - and the rest sits behind "Show N more". */
  /* motion v1: progress lines remember their last length; a changed line is drawn at its NEW length and animates from the old one (.lbf-grow) */
  var GROW = {};
  function summaryHTML(rows, maxTodo, opts) {
    maxTodo = maxTodo == null ? 1 : maxTodo;
    opts = opts || {};
    var todo = rows.filter(function (r) { return !r.ok; }), done = rows.filter(function (r) { return r.ok; });
    function one(r) {
      var bar = '';
      if (r.seg) { var sk = 'seg' + String(r.t || '').replace(/[\d.,]|RM/g, '') + '/' + r.seg[1], segWas = GROW[sk]; GROW[sk] = r.seg[0]; bar ='<span class="lbf-seg">'; for (var i = 0; i < r.seg[1]; i++) bar += '<i' + (i < r.seg[0] ? ' class="on' + (segWas != null && i >= segWas ? ' is-fill' : '') + '"' : '') + '></i>'; bar += '</span>'; }
      else if (r.pct != null) { var gk = String(r.t || '').replace(/[\d.,]|RM/g, ''), gNow = Math.round(Math.min(1, r.pct) * 100), gWas = GROW[gk]; GROW[gk] = gNow;
        bar = '<span class="lbf-gbar"><i' + (gWas != null && gWas !== gNow ? ' class="lbf-grow" style="width:' + gNow + '%;--lbf-from:' + gWas + '%"' : ' style="width:' + gNow + '%"') + '></i></span>'; }
      return '<li class="lbf-sum__row' + (r.ok ? ' is-ok' : '') + (r.cold ? ' is-cold' : '') + (r.act ? ' is-act' : '') + '"' + (r.act ? ' data-sum-act="' + r.act + '"' : '') + '><span class="lbf-sum__t">' + esc(r.t) +
        (r.count ? ' <em>· ' + esc(r.count) + '</em>' : '') + '</span>' + (r.sub ? '<span class="lbf-sum__sub">' + esc(r.sub) + '</span>' : '') + bar + '</li>';
    }
    var shownTodo = todo.slice(0, maxTodo), rest = todo.slice(maxTodo);
    if (opts.cap) {
      /* Carl 2026-09-26: ONE thing in progress up front - a checkout blocker, else free delivery, else the closest
         gift (pri 1/2/3); the wins fill the rest of the 3 lines; everything else behind "Show all" */
      var todos = todo.filter(function (r) { return r.block; }).concat(todo.filter(function (r) { return !r.block; }).sort(function (a, b) { return (a.pri || 5) - (b.pri || 5); }));
      var wins = done.slice().sort(function (a, b) { return (a.rank || 9) - (b.rank || 9); });
      var hasBlock = todos.length && todos[0].block;
      var lead = (hasBlock || wins.length < opts.cap) ? todos.slice(0, 1) : [], room = opts.cap - lead.length; /* 3 wins already? the progress waits in Show all (a blocker never does) */
      var hidden = todos.slice(lead.length);
      done = wins.slice(0, room); shownTodo = lead;
      rest = wins.slice(room).concat(hidden);
      /* Carl 2026-09-26: collapsed = no separator; "Show all" = EVERYTHING won, a line, then everything in progress */
      var compact = '<ul class="lbf-sum">' + done.map(one).join('') + shownTodo.map(one).join('') + '</ul>';
      if (!rest.length || opts.noToggle) return compact;
      return compact + '<ul class="lbf-sum lbf-sum__rest lbf-sum--full" hidden>' + wins.map(one).join('') +
        (wins.length && todos.length ? '<li class="lbf-sum__div" aria-hidden="true"></li>' : '') + todos.map(one).join('') + '</ul>' +
        '<button type="button" class="lbf-sum__toggle" aria-expanded="false">' + esc(lbnT('cart.show_all', 'Show all')) + '</button>';
    }
    var html = '<ul class="lbf-sum">' + done.map(one).join('') +
      (done.length && shownTodo.length ? '<li class="lbf-sum__div" aria-hidden="true"></li>' : '') + shownTodo.map(one).join('') + '</ul>';
    /* Carl 2026-09-26: "Show all" - and once open, "Show less" sits UNDER the last pending item */
    if (rest.length && !opts.noToggle) html += '<ul class="lbf-sum lbf-sum__rest" hidden>' + rest.map(one).join('') + '</ul>' +
      '<button type="button" class="lbf-sum__toggle" aria-expanded="false">' + esc(lbnT('cart.show_all', 'Show all')) + '</button>';
    return html;
  }
  function pointsHTML(c) {
    var pts = Math.floor((c.total_price || 0) / 100);
    if (!pts) return '';
    var star = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>';
    /* Carl 2026-09-26 (Huel pattern): "Estimated: 230+ Foodie Points" */
    var txt = '<span class="lbf-pts__t">' + esc(lbnT('cart.points_estimated', 'Estimated:')) + ' <strong>' + esc(lbnT('cart.points_count', '{{ n }}+ Foodie Points', { n: pts })) + '</strong></span>';
    var chev = '<svg class="lbf-pts__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
    /* Carl 2026-09-26 (Huel pattern): one line on what points are for + a CTA. Logged out, logging in comes first. */
    var body = isLogged()
      ? '<p class="lbf-pts__p">' + esc(lbnT('cart.points_redeem', 'Redeem your Foodie Points for rewards on your next orders.')) + '</p><a class="lbf-pts__cta" href="' + ROOT + '#joy-open" data-pts-cta="rewards">' + esc(lbnT('cart.points_explore', 'Explore rewards ›')) + '</a>'
      : '<p class="lbf-pts__p">' + esc(lbnT('cart.points_login_body', 'Log in to collect them, then redeem your Foodie Points for rewards on your next orders.')) + '</p><a class="lbf-pts__cta lbf-pts__cta--main" href="' + ROOT + 'account/login" data-pts-cta="login">' + esc(lbnT('cart.points_login_cta', 'Log in to collect')) + '</a>';
    /* Carl 2026-09-26: starts CLOSED; the shopper opens it with the arrow */
    return '<div class="lbf-pts"><button type="button" class="lbf-pts__h" aria-expanded="false">' + star + txt + chev + '</button><div class="lbf-pts__b">' + body + '</div></div>';
  }

  /* ---- cross-sell (Carl 2026-09-26: "push for all these different mechanics") ----
     One carousel, every card says WHY it is there, in this order:
       1. gets a gift closer    "Counts to FREE Minced Chicken"  (dishes carrying that promo; ones not yet in the cart first)
       2. Buy 3 Free 1 top-up   "Add 2, get 1 FREE"              (the SKU already in the cart, the exact number needed)
       3. pairs                 "Goes with Bak Kut Teh"          (Shopify's related picks of each cart dish)
       4. a side                "Add a side" / "Add rice"        (chilli sauce, basmathi rice)
     Never: frozen into a ready-to-eat-only cart, the knuckle, gift items, sold out. Max 8 cards. */
  var SIDES = [['malacca-baba-chilli-sauce', 'Add a side'], ['basmathi-rice', 'Add rice']];
  function crossSell(c) {
    var lines = plain(c);
    var inCart = {}; lines.forEach(function (li) { inCart[li.product_id] = 1; });
    var hasFrozen = lines.some(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN; });
    var seenP = {};
    var src = lines.filter(function (li) { if (seenP[li.product_id]) return false; seenP[li.product_id] = 1; return true; }).slice(0, 4);
    return Promise.all([
      Promise.all(src.map(function (li) {
        return fetch(ROOT + 'recommendations/products.json?product_id=' + li.product_id + '&intent=related&limit=10')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return { from: li, list: j.products || [] }; })
          .catch(function () { return { from: li, list: [] }; });
      })),
      Promise.all(SIDES.map(function (s) { return productInfo(s[0]); })),
      Promise.all(lines.map(function (li) { return productInfo(li.handle); })),
      withTags(c)
    ]).then(function (res) {
      var ok = function (p) {
        if (!p) return false;
        var t = lower(p.tags);
        return !!variantOf(p) && t.indexOf(SOLO) === -1 && t.indexOf('free-gift') === -1 && (hasFrozen || kindOf(p) !== 'frozen');
      };
      var out = [], used = {};
      /* a mix, not a wall of one mechanic: at most 2 cards per gift, 2 top-ups, then pairs and sides */
      var perWhy = {};
      function push(p, why, qty, v, cap) {
        if (out.length >= 8 || !p || used[p.id] || !ok(p)) return;
        if (cap && (perWhy[why] || 0) >= cap) return;
        perWhy[why] = (perWhy[why] || 0) + 1;
        used[p.id] = 1; out.push({ p: p, v: v || variantOf(p), why: why, qty: qty || 1 });
      }
      var pool = [], fromOf = {};
      res[0].forEach(function (b) { b.list.forEach(function (p) { if (!fromOf[p.id]) { fromOf[p.id] = b.from; pool.push(p); } }); });
      var prog = promoProgress(tagLines(c)).filter(function (p) { return !p.earned; }).sort(function (a, b) { return a.rem - b.rem; });
      /* 1 */
      prog.filter(function (p) { return p.rule.kind === 'group'; }).forEach(function (g) {
        var why = 'Counts to FREE ' + g.rule.gift;
        pool.filter(function (p) { return !inCart[p.id] && lower(p.tags).indexOf(g.rule.tag) !== -1; }).forEach(function (p) { push(p, why, 1, null, 2); });
      });
      /* 2 - off (Carl 2026-09-26: nothing already in the cart is suggested; the top-up now lives on the cart line) */
      [].forEach(function (s) {
        var idx = -1;
        lines.forEach(function (l, i) { if (idx < 0 && String(l.variant_id) === String(s.variantId)) idx = i; });
        var p = idx > -1 ? res[2][idx] : null;
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(s.variantId); })[0];
        if (out.filter(function (o) { return o.qty > 1 || /FREE$/.test(o.why); }).length < 2) push(p, 'Add ' + s.rem + ', get ' + s.rule.free + ' FREE', s.rem, v);
      });
      /* 3 */
      pool.filter(function (p) { return !inCart[p.id]; }).forEach(function (p) { push(p, 'Goes with ' + shortTitle(fromOf[p.id].product_title)); });
      /* 4 */
      res[1].forEach(function (p, i) { if (p && !inCart[p.id]) push(p, SIDES[i][1]); });
      return out;
    });
  }
  function xsCardHTML(x, i) {
    var p = x.p, v = x.v;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    img = String(img || '');
    if (img.indexOf('//') === 0) img = 'https:' + img;
    /* Carl 2026-09-26: current price only, in black; SRP + price does not fit the card */
    var M = (BOOT.meta || {})[p.handle] || [];
    var badge = (M[3] || lower(p.tags).indexOf('bs') !== -1) ? { text: lbnT('cart.badge_best_seller', 'Best Seller'), bg: '#FFE100', fg: '#4D3B2A' } : promoBadges(p.tags)[0];
    return '<div class="lbf-xs__card">' +
      '<a class="lbf-xs__img" href="' + ROOT + 'products/' + esc(p.handle) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" width="88" height="88" loading="eager" decoding="async">' : '') +
      (badge ? '<span class="lbf-xs__badge" style="background:' + esc(badge.bg || '#FF7818') + ';color:' + esc(badge.fg || '#fff') + '">' + esc(badge.text) + '</span>' : '') + '</a>' +
      '<div class="lbf-xs__b">' + pillsHTML(M) +
      '<a class="lbf-xs__n" href="' + ROOT + 'products/' + esc(p.handle) + '">' + esc(shortTitle(p.title)) + '</a>' +
      '<div class="lbf-xs__row"><span class="lbf-xs__p">' + money(v.price * x.qty) + '</span>' +
      '<button type="button" class="lbf-xs__add" data-xs-add="' + v.id + '" data-qty="' + x.qty + '" data-price="' + (v.price * x.qty) + '" data-handle="' + esc(p.handle) + '" data-why="' + esc(x.why) + '" data-pos="' + (i + 1) + '">' + esc(x.qty > 1 ? lbnT('cart.rail_add_n', 'Add {{ n }}', { n: x.qty }) : lbnT('cart.rail_add', 'Add')) + '</button></div></div></div>';
  }
  /* the collection card's own pills: custom.capsule_pax · custom.portion_weight · custom.capsule_time (same icons, same framing) */
  var PILL_SVG = {
    pax: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="7" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>',
    w: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6"/><path d="M10 3v4h4V3"/><path d="M7 7h10l2 4v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8l2-4z"/></svg>',
    t: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 15"/></svg>'
  };
  function pillsHTML(M) {
    var out = [];
    if (M[0]) out.push(PILL_SVG.pax + esc(M[0]));
    if (M[1]) out.push(PILL_SVG.w + esc(M[1]));
    if (M[2]) out.push(PILL_SVG.t + esc(String(M[2]).replace(/\s*(mins?|minutes?)\b/i, lbnT('product.pill_min_short', 'min')).replace(/\s+/g, '')));
    return out.length ? '<div class="lbf-card-meta">' + out.map(function (x) { return '<span class="lbf-card-meta__item">' + x + '</span>'; }).join('') + '</div>' : '';
  }
  function arrow(d) { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>'; }
  function railHTML(items, title) {
    if (!items.length) return '';
    return '<div class="lbf-xs__head"><h3>' + esc(title || lbnT('cart.rail_title_default', 'You may also like')) + '</h3>' + (items.length > 1 ? '<div class="lbf-xs__nav"><button type="button" data-xs-nav="-1" aria-label="' + esc(lbnT('common.previous', 'Previous')) + '">' + arrow(-1) + '</button><button type="button" data-xs-nav="1" aria-label="' + esc(lbnT('common.next', 'Next')) + '">' + arrow(1) + '</button></div>' : '') + '</div>' +
      '<div class="lbf-xs__track">' + items.map(xsCardHTML).join('') + '</div>' +
      (items.length > 1 ? '<div class="lbf-xs__dots" aria-hidden="true">' + items.map(function (x, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>' : '');
  }
  function railState(root) {
    var tr = root.querySelector('.lbf-xs__track'); if (!tr) return;
    var card = tr.querySelector('.lbf-xs__card'); if (!card) return;
    var step = card.getBoundingClientRect().width + 12;
    var i = Math.round(tr.scrollLeft / step), max = tr.scrollWidth - tr.clientWidth - 2;
    if (tr.scrollLeft >= max) i = tr.querySelectorAll('.lbf-xs__card').length - 1;
    Array.prototype.forEach.call(root.querySelectorAll('.lbf-xs__dots i'), function (d, k) { d.classList.toggle('on', k === i); });
    var nav = root.querySelectorAll('[data-xs-nav]');
    if (nav[0]) nav[0].disabled = tr.scrollLeft <= 2;
    if (nav[1]) nav[1].disabled = tr.scrollLeft >= max;
  }
  function bindRail(root, surface) {
    if (!root || root.__lbfXs) return;
    root.__lbfXs = 1;
    var rt = 0;
    root.addEventListener('scroll', function () { var now = Date.now(); if (now - rt > 60) { rt = now; railState(root); } clearTimeout(root.__rsT); root.__rsT = setTimeout(function () { railState(root); }, 120); }, true);
    root.addEventListener('click', function (e) {
      var n = e.target.closest('[data-xs-nav]');
      if (n) { var tr = root.querySelector('.lbf-xs__track'); var card = tr && tr.querySelector('.lbf-xs__card'); if (tr && card) tr.scrollLeft += (+n.getAttribute('data-xs-nav')) * (card.getBoundingClientRect().width + 12); setTimeout(function () { railState(root); }, 350); return; }
      var a = e.target.closest('[data-xs-add]');
      if (!a || a.disabled || a.classList.contains('lbf-add-busy')) return;
      e.preventDefault();
      var drawerAdd = !!root.closest('cart-drawer');
      if (drawerAdd && window.LBF_DRAWER) window.LBF_DRAWER.startLoading();
      var q = +a.getAttribute('data-qty') || 1, label = a.textContent;
      var done = document.createElement('span'); done.className = 'lbf-xs__added'; done.textContent = lbnT('cart.rail_added', '✓ Added');
      LBF_CART.setAdding(a, true);
      LBF_CART.addItems([{ id: a.getAttribute('data-xs-add'), quantity: q }]).then(function (r) {
        LBF_CART.setAdding(a, false);
        if (!r.ok) {
          a.textContent = label;
          if (drawerAdd && window.LBF_DRAWER) window.LBF_DRAWER.stopLoading();
          return;
        }
        a.replaceWith(done);
        var addPdp = surface === 'sheet' ? (location.pathname.split('/products/')[1] || '') : 'cart';
        var addPick = a.getAttribute('data-handle'), addPos = +a.getAttribute('data-pos'), addWhy = a.getAttribute('data-why');
        track('lbf_pair_add', { pdp: addPdp, pick: addPick, position: addPos, reason: addWhy, surface: surface });
        if (surface === 'sheet') {
          /* new name for the sheet add; lbf_pair_add surface=sheet is kept for one release */
          track('lbf_sheet_add', { pdp: addPdp, pick: addPick, position: addPos, qty: q, reason: addWhy, value: (+a.getAttribute('data-price') || 0) / 100 });
          bumpSheetAdd();
        }
      });
    });
  }
  /* ---- category rails for the "Added" sheet: the collection page's own tabs ----
     Quick Meals For One = type Retort (minus the Healthier Choice soups, which get their own rail)
     Better For You Soups = custom.promotion "Healthier Choice" (list shipped in the HTML: __LBF_CJ.healthy)
     Frozen Family Packs = type Frozen - only for a cart that already has frozen (never frozen into a ready-to-eat-only cart)
     Never: what is already in the cart, the knuckle (cc_solo_ok), gifts, sold out. Max 8 per rail. */
  var catP = null;
  function catalog() {
    if (catP) return catP;
    /* one list of every product + tags: also the fallback when a single product lookup is throttled */
    catP = fetch(ROOT + 'collections/all/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        return (j.products || []).map(function (p) {
          catTags[p.handle] = p.tags || [];
          var img = p.images && p.images[0] ? (p.images[0].src || '') : '';
          return { id: p.id, handle: p.handle, title: p.title, tags: p.tags || [], type: p.product_type || '', featured_image: img,
            variants: (p.variants || []).map(function (v) { return { id: v.id, available: v.available !== false, price: Math.round(parseFloat(v.price) * 100), compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0 }; }) };
        });
      }).catch(function () { return []; });
    return catP;
  }
  LBF_CART.prefetchCatalog = catalog;
  function categoryRails(c, handle) {
    var lines = paidLines(c);
    var inCart = {}; lines.forEach(function (li) { inCart[li.product_id] = 1; });
    var hasFrozen = lines.some(function (li) { return String(li.product_type || '').toLowerCase() === FROZEN; });
    var healthy = (BOOT.healthy || []).filter(Boolean);
    return catalog().then(function (all) {
      var ok = function (p) {
        var t = lower(p.tags);
        /* Carl 2026-09-26: nothing already in the cart is ever suggested */
        return !inCart[p.id] && variantOf(p) && variantOf(p).price > 0 && t.indexOf(SOLO) === -1 && t.indexOf('free-gift') === -1 && t.indexOf('trialbox') === -1 && !/gift/i.test(p.handle);
      };
      /* Carl 2026-09-26: a seasonal dish ships on its own (split shipping) - its sheet offers ONLY other seasonal
         dishes, never regular ones. Seasonal = cc_solo_ok (the tag that also lets it check out without the frozen
         minimum). Bundles carrying the old cc_solo_ok MOQ bypass are left out. None on sale -> no rail at all. */
      var me = all.filter(function (p) { return p.handle === handle; })[0];
      var meTags = lower(me ? me.tags : (prodTags[handle] || []));
      if (meTags.indexOf(SOLO) !== -1) {
        var sea = all.filter(function (p) { var v = variantOf(p), tags = lower(p.tags); return !inCart[p.id] && p.handle !== handle && v && v.price > 0 && tags.indexOf(SOLO) !== -1 && tags.indexOf('free-gift') === -1 && tags.indexOf('trialbox') === -1 && String(p.type).toLowerCase() === FROZEN; });
        return sea.length ? [{ title: lbnT('cart.rail_seasonal_specials', 'More Seasonal Specials'), items: sea.slice(0, 8).map(function (p) { return { p: p, v: variantOf(p), why: 'More Seasonal Specials', qty: 1 }; }) }] : [];
      }
      var rte = all.filter(function (p) { return String(p.type).toLowerCase() === 'retort' && ok(p); });
      /* Carl 2026-09-26: the soups lead, as "Better For You Soups" */
      var rails = [
        { title: lbnT('cart.rail_better_for_you_soups', 'Better For You Soups'), why: 'Better For You Soups', items: rte.filter(function (p) { return healthy.indexOf(p.handle) !== -1; }) },
        { title: lbnT('cart.rail_quick_meals_for_one', 'Quick Meals For One'), why: 'Quick Meals For One', items: rte.filter(function (p) { return healthy.indexOf(p.handle) === -1; }) }
      ];
      if (hasFrozen) rails.push({ title: lbnT('cart.rail_frozen_family_packs', 'Frozen Family Packs'), why: 'Frozen Family Packs', items: all.filter(function (p) { return String(p.type).toLowerCase() === FROZEN && ok(p); }) });
      return rails.map(function (r) { return { title: r.title, items: r.items.slice(0, 8).map(function (p) { return { p: p, v: variantOf(p), why: r.why, qty: 1 }; }) }; })
        .filter(function (r) { return r.items.length; });
    });
  }
  LBF_CART.withTags = withTags;
  LBF_CART.summaryRows = function (c) { return withTags(c || cart).then(summaryRowsFor); };
  LBF_CART.summaryHTML = summaryHTML;
  LBF_CART.pointsHTML = pointsHTML;
  LBF_CART.crossSell = crossSell;
  LBF_CART.railHTML = railHTML;
  LBF_CART.bindRail = bindRail;
  LBF_CART.track = track;

  var sheetRequest = 0, sheetHandle = '';
  function openAddedSheet(handle) {
    var request = ++sheetRequest;
    if (!cart) return;
    if (!sheetEl) {
      sheetEl = document.createElement('div');
      sheetEl.className = 'lbf-sheet';
      sheetEl.innerHTML = '<div class="lbf-sheet__scrim" data-close></div><section class="lbf-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="lbf-sheet-t" tabindex="-1">' +
        '<header class="lbf-sheet__head"><h2 id="lbf-sheet-t">' + esc(lbnT('cart.sheet_title', 'Added To Your Cart')) + '</h2><button type="button" class="lbf-sheet__x" data-close aria-label="' + esc(lbnT('common.close', 'Close')) + '">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>' +
        '<div class="lbf-sheet__body"><div class="lbf-sum-wrap"></div><div class="lbf-sheet__pts"></div><div class="lbf-sheet__rails"></div></div>' +
        '<div class="lbf-sheet__foot"><a class="lbf-sheet__cta" href="' + ROOT + 'cart">' + esc(lbnT('cart.sheet_view_cart', 'VIEW CART')) + '</a></div></section>';
      document.body.appendChild(sheetEl);
      sheetEl.addEventListener('click', function (e) {
        var c = e.target.closest('[data-close]');
        if (c) { closeSheet(c.classList.contains('lbf-sheet__scrim') ? 'scrim' : 'button'); return; }
        if (e.target.closest('.lbf-sheet__cta')) track('lbf_sheet_cta', { pdp: sheetHandle });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheetEl.classList.contains('is-open')) closeSheet('escape'); });
      LBF_CART.on(function (c) { if (sheetEl.classList.contains('is-open')) paintSheetTop(c); });
    }
    paintSheetTop(cart);
    var railsEl = sheetEl.querySelector('.lbf-sheet__rails');
    railsEl.innerHTML = '<section class="lbf-xs"><div class="lbf-xs__head"><h3>&nbsp;</h3></div><div class="lbf-xs__track"><div class="lbf-xs__card is-skel"></div><div class="lbf-xs__card is-skel"></div></div></section>';
    categoryRails(cart, handle).then(function (rails) {
      if (request !== sheetRequest) return;
      railsEl.innerHTML = rails.map(function (r) { return '<section class="lbf-xs" aria-label="' + esc(r.title) + '">' + railHTML(r.items, r.title) + '</section>'; }).join('');
      Array.prototype.forEach.call(railsEl.querySelectorAll('.lbf-xs'), function (s) { bindRail(s, 'sheet'); railState(s); });
    });
    sheetEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    sheetHandle = handle;
    track('lbf_sheet_view', { pdp: handle, sheet_items: cart && cart.item_count || 0 });
    setTimeout(function () { sheetEl.querySelector('.lbf-sheet__panel').focus(); }, 30);
  }
  function paintSheetTop(c) {
    withTags(c).then(function (c2) {
      /* the sheet: what they have earned + at most 2 things still open (delivery first, then the nearest gift) */
      sheetEl.querySelector('.lbf-sum-wrap').innerHTML = summaryHTML(summaryRowsFor(c2), 1, { cap: 3, noToggle: true }); /* Carl 2026-09-26 (A): one progress line, the cart's rule */
      sheetEl.querySelector('.lbf-sheet__pts').innerHTML = ''; /* Carl 2026-09-26: points live on the cart page only */
    });
  }
  /* method: how the shopper closed it (scrim, button, escape). No method = closed by code (drawer opening), not tracked. */
  function closeSheet(method) {
    var wasOpen = sheetEl.classList.contains('is-open');
    sheetEl.classList.remove('is-open'); document.body.style.overflow = '';
    if (method && wasOpen) track('lbf_sheet_dismiss', { pdp: sheetHandle, method: method });
  }

  /* Keep existing cart rows mounted. Quantity changes only patch the quantity/price
     cells; add/remove reorders the existing keyed rows and inserts/removes only the
     changed row. Product badges therefore never disappear while unrelated content
     catches up after a cart response. */
  function drawerRowKey(row) {
    var input = row && row.querySelector('input[data-quantity-line-key]');
    return input ? input.getAttribute('data-quantity-line-key') || '' : '';
  }
  function syncAttributes(target, source) {
    Array.prototype.slice.call(target.attributes || []).forEach(function (attr) {
      if (!source.hasAttribute(attr.name)) target.removeAttribute(attr.name);
    });
    Array.prototype.slice.call(source.attributes || []).forEach(function (attr) {
      target.setAttribute(attr.name, attr.value);
    });
  }
  function syncMutableRow(target, source) {
    var wasLoading = target.classList.contains('lbf-row-loading');
    syncAttributes(target, source);
    if (wasLoading) target.classList.add('lbf-row-loading');
    ['.cart-item__quantity', '.cart-item__totals.medium-hide', '.cart-item__totals.small-hide'].forEach(function (selector) {
      var currentCell = target.querySelector(selector), sourceCell = source.querySelector(selector);
      if (!currentCell || !sourceCell) return;
      syncAttributes(currentCell, sourceCell);
      currentCell.innerHTML = sourceCell.innerHTML;
    });
  }
  function drawerStructureKey(node) {
    var keys = ['lbf-cart-sec--frozen', 'lbf-moq-helper-slot', 'lbf-cj-choice-slot', 'lbf-cart-sec--rte'];
    for (var i = 0; i < keys.length; i += 1) if (node.classList.contains(keys[i])) return keys[i];
    return '';
  }
  function cartStateKey(c) {
    if (!c) return '';
    return [c.item_count || 0, c.total_price || 0, (c.items || []).map(function (item) {
      return String(item.key || item.variant_id || '') + ':' + String(item.quantity || 0);
    }).join('|'), (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).sort().join(',')].join('::');
  }
  function syncDrawerInner(sourceInner) {
    var currentInner = document.querySelector('#CartDrawer .drawer__inner');
    if (!currentInner || !sourceInner) return false;
    var sourceBody = sourceInner.querySelector('.cart-items tbody');
    var currentBody = currentInner.querySelector('.cart-items tbody');
    var sourceEmpty = !!sourceInner.querySelector('.drawer__inner-empty');
    var currentEmpty = !!currentInner.querySelector('.drawer__inner-empty');
    // Empty and populated carts have different shells, not just different rows.
    if (sourceEmpty !== currentEmpty || !sourceBody || !currentBody) {
      currentInner.innerHTML = sourceInner.innerHTML;
      return true;
    }
    var currentItems = currentInner.querySelector('cart-drawer-items');
    var sourceItems = sourceInner.querySelector('cart-drawer-items');
    if (currentItems && sourceItems) syncAttributes(currentItems, sourceItems);

    var rows = {}, structures = {};
    Array.prototype.forEach.call(currentBody.children, function (node) {
      if (node.classList.contains('cart-item')) {
        var key = drawerRowKey(node); if (key) rows[key] = node;
      } else {
        var structureKey = drawerStructureKey(node); if (structureKey) structures[structureKey] = node;
      }
    });

    var nextBody = document.createDocumentFragment();
    Array.prototype.forEach.call(sourceBody.children, function (sourceNode) {
      if (sourceNode.classList.contains('cart-item')) {
        var rowKey = drawerRowKey(sourceNode), row = rowKey && rows[rowKey];
        if (row) {
          syncMutableRow(row, sourceNode);
          nextBody.appendChild(row);
        } else {
          nextBody.appendChild(sourceNode.cloneNode(true));
        }
        return;
      }
      var key = drawerStructureKey(sourceNode), structure = key && structures[key];
      if (!structure) {
        structure = sourceNode.cloneNode(true);
        var newTitle = structure.querySelector('.lbf-cart-sec__title');
        if (newTitle) newTitle.__lbf = 1;
        nextBody.appendChild(structure);
      } else {
        if (key === 'lbf-cart-sec--frozen' || key === 'lbf-cart-sec--rte') {
          structure.innerHTML = sourceNode.innerHTML;
          var title = structure.querySelector('.lbf-cart-sec__title');
          if (title) title.__lbf = 1;
        }
        nextBody.appendChild(structure);
      }
    });
    currentBody.replaceChildren(nextBody);

    var currentSubtotal = currentInner.querySelector('#lbf-cj-drawer-foot .lbf-cj-f__row:first-child');
    var sourceSubtotal = sourceInner.querySelector('#lbf-cj-drawer-foot .lbf-cj-f__row:first-child');
    if (currentSubtotal && sourceSubtotal) currentSubtotal.innerHTML = sourceSubtotal.innerHTML;
    return true;
  }
  window.LBF_CART_DRAWER_SYNC = syncDrawerInner;

  /* ======================= LBF_DRAWER (Carl 2026-09-26: "I prefer cart drawer") =======================
     Our adds (card steppers, tray, boxes, rails) write to /cart/*.js directly, so Dawn never re-renders its drawer.
     After every cart change the drawer is refreshed quietly from ?sections=cart-drawer, so it is already right when
     it opens. Every "VIEW CART" link opens the drawer instead of loading /cart (the header icon is Dawn's own). */
  var LBF_DRAWER = (function () {
    function el() { return document.querySelector('cart-drawer'); }
    var pend = null, settling = null, opening = null, revision = 0, stale = false, t = 0, seen = false, loadingFailT = 0, loadingOffT = 0, loadingStarted = 0;
    var lastCartKey = '', externalWrites = 0, externalWaiters = [], navigationCheck = null;
    function syncControls(on) {
      document.documentElement.classList.toggle('lbf-cart-syncing', !!on);
      Array.prototype.forEach.call(document.querySelectorAll('.lbfcb-viewcart'), function (button) {
        /* Still tappable while syncing: open() waits for the cart and opens it, so one tap is enough. */
        if (on) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
    }
    function setLoading(on, force) {
      var d = el(); if (!d) return;
      if (!on && (LBF_CART.isPending() || externalWrites)) return;
      if (!on && !force && loadingStarted) {
        var remaining = 180 - (Date.now() - loadingStarted);
        if (remaining > 0) {
          clearTimeout(loadingOffT);
          loadingOffT = setTimeout(function () { setLoading(false, true); }, remaining);
          return;
        }
      }
      clearTimeout(loadingOffT);
      d.classList.toggle('lbf-cjd-loading', !!on);
      var inner = d.querySelector('.drawer__inner');
      if (inner) {
        if (on) inner.setAttribute('aria-busy', 'true');
        else inner.removeAttribute('aria-busy');
      }
      clearTimeout(loadingFailT);
      if (on) loadingStarted = Date.now();
      else {
        loadingStarted = 0;
        Array.prototype.forEach.call(d.querySelectorAll('.lbf-row-loading'), function (row) { row.classList.remove('lbf-row-loading'); });
      }
      if (on) loadingFailT = setTimeout(function () { setLoading(false); }, 6000);
    }
    function waitForPaint(c) {
      var key = cartStateKey(c || LBF_CART.get());
      if (!key || window.LBF_CART_LAST_PAINT_KEY === key) return Promise.resolve();
      return new Promise(function (resolve) {
        var timer = 0;
        function done() {
          clearTimeout(timer);
          document.removeEventListener('lbf:cart-painted', onPaint);
          resolve();
        }
        function onPaint(e) { if (e && e.detail && e.detail.key === key) done(); }
        document.addEventListener('lbf:cart-painted', onPaint);
        timer = setTimeout(done, 1500);
      });
    }
    function whenExternalSettled() {
      return externalWrites ? new Promise(function (resolve) { externalWaiters.push(resolve); }) : Promise.resolve();
    }
    function beginCommit() {
      externalWrites += 1; revision += 1; stale = true;
      syncControls(true); setLoading(true);
    }
    /* Dawn has drawn the drawer from its own write reply: remember which commit that covers */
    var domRev = -1, domWaiters = [];
    function markDomReady() { domRev = revision; domWaiters.splice(0).forEach(function (resolve) { resolve(); }); }
    function whenDomReady() {
      if (domRev === revision) return Promise.resolve(true);
      return new Promise(function (resolve) {
        var t2 = setTimeout(function () { resolve(domRev === revision); }, 1500);
        domWaiters.push(function () { clearTimeout(t2); resolve(domRev === revision); });
      });
    }
    function markModelReady(c, opts) {
      externalWrites = Math.max(0, externalWrites - 1);
      if (externalWrites) return;
      externalWaiters.splice(0).forEach(function (resolve) { resolve(); });
      if (!(opts && opts.dawnDom)) { refresh().catch(function () {}); return; }
      whenDomReady().then(function (fresh) { return fresh ? reuseDom() : refresh(); }).catch(function () {});
    }
    /* the drawer markup already is the reply to the last write: skip the section re-read, just repaint and unlock */
    function reuseDom() {
      if (LBF_CART.isPending() || externalWrites || domRev !== revision) return refresh();
      clearTimeout(t);
      var requestedRevision = revision;
      stale = false;
      document.dispatchEvent(new CustomEvent('lbf:drawer-refreshed'));
      return waitForPaint(LBF_CART.get()).then(function () {
        if (requestedRevision !== revision || stale || LBF_CART.isPending() || externalWrites) return refresh();
        syncControls(false); setLoading(false);
      });
    }
    function abortCommit() { markModelReady(); }
    function refresh() {
      if (!el()) return Promise.resolve();
      clearTimeout(t);
      if (LBF_CART.isPending() || externalWrites) {
        syncControls(true); setLoading(true);
        if (!settling) settling = Promise.all([LBF_CART.whenSettled(), whenExternalSettled()]).then(function () { settling = null; return refresh(); });
        return settling;
      }
      if (pend) return pend;
      var requestedRevision = revision;
      syncControls(true); setLoading(true);
      pend = fetch(ROOT + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Cart refresh failed'); return r.json(); })
        .then(function (j) {
          if (requestedRevision !== revision || LBF_CART.isPending() || externalWrites) return;
          var d = el(); if (!d || !j || !j['cart-drawer']) throw new Error('Cart markup unavailable');
          var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
          var src = doc.querySelector('#CartDrawer .drawer__inner'), cur = document.querySelector('#CartDrawer .drawer__inner');
          if (!src || !cur) throw new Error('Cart markup unavailable');
          var sc = cur.querySelector('.lbf-cjd-scroll'), top = sc ? sc.scrollTop : 0;
          if (!syncDrawerInner(src)) cur.innerHTML = src.innerHTML;
          var sc2 = cur.querySelector('.lbf-cjd-scroll'); if (sc2) sc2.scrollTop = top;
          var srcDrawer = doc.querySelector('cart-drawer');
          d.classList.toggle('is-empty', !!(srcDrawer && srcDrawer.classList.contains('is-empty')));
          stale = false;
          // Even a keyed update can replace the footer. Prepare it before View Cart becomes ready.
          document.dispatchEvent(new CustomEvent('lbf:drawer-refreshed'));
        })
        .then(function (result) {
          pend = null;
          if (requestedRevision !== revision || LBF_CART.isPending() || externalWrites) return refresh();
          return waitForPaint(LBF_CART.get()).then(function () {
            if (stale || LBF_CART.isPending() || externalWrites) return refresh();
            syncControls(false); setLoading(false); return result;
          });
        }).catch(function (error) {
          pend = null; stale = true; syncControls(false); setLoading(false); throw error;
        });
      return pend;
    }
    function schedule() {
      if (!el()) return;
      revision += 1; stale = true; syncControls(true); setLoading(true);
      clearTimeout(t); t = setTimeout(function () { refresh().catch(function () {}); }, 400);
    }
    function open() {
      var d = el();
      if (!d) { window.location.href = ROOT + 'cart'; return; }
      LBF_CART.flush();
      if (sheetEl && sheetEl.classList.contains('is-open')) closeSheet();
      if (opening) return opening;
      var go = function () { if (typeof d.open === 'function') d.open(); track('lbf_drawer_open', {}); };
      if (!navigationCheck && !LBF_CART.isPending() && !externalWrites && !stale && !pend && !settling) {
        go(); return Promise.resolve();
      }
      /* Carl 29 Oct: View Cart looks ready once the count shows; the spinner only answers a tap that has to wait */
      document.documentElement.classList.add('lbf-cart-opening');
      opening = Promise.resolve(navigationCheck).then(function () { return LBF_CART.whenSettled(); }).then(function () {
        return stale || pend || settling || externalWrites ? refresh() : undefined;
      }).then(go).catch(function () {
        LBF_TOAST.show({ kind: 'stock', tile: 'red', icon: 'alert', title: lbnT('cart.toast_refresh_failed', 'Could not refresh your cart'), sub: lbnT('cart.toast_refresh_failed_sub', 'Please try View Cart again.') });
      }).finally(function () { opening = null; document.documentElement.classList.remove('lbf-cart-opening'); });
      return opening;
    }
    LBF_CART.on(function (c, meta) {
      var key = cartStateKey(c), changed = key !== lastCartKey;
      lastCartKey = key;
      if (!seen) { seen = true; return; }
      if (meta && meta.skipDrawerRefresh) return;
      if (changed || LBF_CART.isPending()) schedule();
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      // Back/forward can restore an old DOM and model. Validate quietly; an
      // unchanged cart never starts the loader or requests its section again.
      navigationCheck = load(true).finally(function () { navigationCheck = null; });
    });
    /* arriving from /cart (checkout's cart icon): open the drawer on the page the shopper came back to */
    (function () {
      if (!/[?&]lbf_cart=1(&|$)/.test(location.search) || !el()) return;
      try { var q = location.search.replace(/([?&])lbf_cart=1(&|$)/, '$1').replace(/[?&]$/, ''); history.replaceState(null, '', location.pathname + q + location.hash); } catch (e) {}
      var go = function () { if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(function () { refresh().then(function () { var d = el(); if (d && typeof d.open === 'function') d.open(); }); }); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
      track('lbf_drawer_open', { via: 'cart_url' });
    })();
    /* html.lbf-cjd-open while the drawer is open (hides floating widgets such as the Joy rewards button) */
    (function () { var d = el(); if (!d || !window.MutationObserver) return;
      var sync = function () { document.documentElement.classList.toggle('lbf-cjd-open', d.classList.contains('active')); };
      new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] }); sync(); })();
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]'); if (!a || !el()) return;
      var h = a.getAttribute('href') || '';
      if (!/^(https?:\/\/[^/]+)?\/cart\/?(\?.*)?$/.test(h)) return;
      /* this capture handler stops the click before the sheet's own listener runs, so VIEW CART is counted here (the sheet listener covers the no-drawer case; they never both run) */
      if (a.classList.contains('lbf-sheet__cta')) track('lbf_sheet_cta', { pdp: sheetHandle });
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'CartDrawer-Form' && (navigationCheck || externalWrites || LBF_CART.isPending() || stale || pend || settling)) {
        e.preventDefault(); e.stopImmediatePropagation();
        refresh().catch(function () {});
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === ' ' || e.key === 'Enter') && e.target.closest('#cart-icon-bubble')) {
        e.preventDefault(); e.stopImmediatePropagation(); open();
      }
    }, true);
    return {
      refresh: refresh,
      open: open,
      startLoading: function () { setLoading(true); },
      stopLoading: function () { setLoading(false); },
      beginCommit: beginCommit,
      markDomReady: markDomReady,
      markModelReady: markModelReady,
      abortCommit: abortCommit
    };
  })();
  window.LBF_DRAWER = LBF_DRAWER;
  /* Apps redraw Dawn's drawer through renderContents(), which also OPENS it (QA 2026-09-26: Cart Bot does this every
     time it adds a free gift, so the drawer popped open mid-browse - before it even had the new cart). The drawer now
     only refreshes quietly; it opens when the shopper asks (cart icon, VIEW CART) or right after a Dawn product-form
     add (pages without our tray), which is Dawn's own behaviour. The gift toast still announces the gift. */
  var formAddAt = 0;
  document.addEventListener('submit', function (e) { if (e.target && e.target.closest && e.target.closest('product-form')) formAddAt = Date.now(); }, true);
  (function patchRender() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C) { if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patchRender); return; }
    if (C.prototype.__lbfRender) return;
    C.prototype.__lbfRender = true;
    C.prototype.renderContents = function () {
      var self = this, wantOpen = Date.now() - formAddAt < 8000;
      formAddAt = 0;
      LBF_DRAWER.refresh().then(function () { if (wantOpen && typeof self.open === 'function') self.open(); });
    };
  })();
  /* cart-drawer.js calls cartDrawerItems.dispatchViewEvent() on open; this theme's cart.js (CartItems) has no such
     method, so Dawn's open() threw after the drawer had opened. A no-op keeps open() clean (analytics unaffected). */
  (function patchViewEvent() {
    var C = window.customElements && customElements.get('cart-drawer-items');
    if (!C) { if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer-items').then(patchViewEvent); return; }
    if (typeof C.prototype.dispatchViewEvent !== 'function') C.prototype.dispatchViewEvent = function () {};
  })();

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lbf-sum__toggle');
    if (!b) return;
    var rest = b.parentNode.querySelector('.lbf-sum__rest');
    if (!rest) return;
    var open = rest.hidden;
    rest.hidden = !open;
    /* the full list replaces the compact one while open (it repeats the compact lines, grouped) */
    var compact = rest.classList.contains('lbf-sum--full') && b.parentNode.querySelector('.lbf-sum:not(.lbf-sum__rest)');
    if (compact) compact.hidden = open;
    b.textContent = open ? lbnT('cart.show_less', 'Show less') : lbnT('cart.show_all', 'Show all');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function init() {
    load();
    watchGrid();
    initTrays();
    /* the pop-up's content arrives later, by fetch */
    var trayT = 0;
    new MutationObserver(function () { clearTimeout(trayT); trayT = setTimeout(initTrays, 80); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Order labels follow the cart (Carl 2026-10-13). lbf_box, lbf_starter_box and lbf_bundle_* are order-level labels;
 * each dish line carries its own _lbf_offer_* marker. When a box's dishes leave the cart, its label goes too, so an
 * order never names a box it does not contain. Only removes, never invents. Lines from before this change cannot
 * name their builder box (_bundle_id without _lbf_offer_key), so their labels are kept. */
(function () {
  if (window.__lbfLabelSync) return;
  window.__lbfLabelSync = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BOX = ['lbf_box', 'lbf_box_source', 'lbf_box_edited', 'lbf_box_substituted', 'lbf_box_version', 'lbf_box_variant'];
  var timer = null, running = false;

  function props(li) {
    var p = li && li.properties;
    if (!p) return {};
    if (!Array.isArray(p)) return p;
    var o = {};
    p.forEach(function (x) { if (x) o[x[0] || x.name] = x[1] || x.value; });
    return o;
  }

  function staleLabels(cart) {
    var a = cart.attributes || {}, lines = (cart.items || []).map(props), out = {}, keys = {}, names = {};
    var legacyBuilder = lines.some(function (p) { return p._bundle_id && !p._lbf_offer_key; });
    lines.forEach(function (p) {
      [p._lbf_box, p._lbf_offer_key].forEach(function (k) { if (k) keys[k] = true; });
      [p._lbf_box_name, p._lbf_offer_name].forEach(function (n) { if (n) names[n] = true; });
    });
    if ((a.lbf_bundle_builder_used || a.lbf_bundle_source_page) && !lines.some(function (p) { return p._bundle_id; })) {
      out.lbf_bundle_builder_used = '';
      out.lbf_bundle_source_page = '';
    }
    if (a.lbf_box) {
      var all = String(a.lbf_box).split(',').filter(function (k) { return k; });
      var kept = all.filter(function (k) { return keys[k] || legacyBuilder; });
      if (!kept.length) BOX.forEach(function (k) { if (a[k]) out[k] = ''; });
      else if (kept.length !== all.length) out.lbf_box = kept.join(',');
    }
    var starter = a.lbf_starter_box;
    if (starter && !(names[starter] || (starter === 'Self-built' && keys['self-built']) || legacyBuilder)) {
      out.lbf_starter_box = '';
      out.lbf_starter_box_edited = '';
    }
    return out;
  }

  function run() {
    if (running) return;
    running = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fix = staleLabels(cart);
        if (!Object.keys(fix).length) return null;
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: fix })
        });
      })
      .catch(function () {})
      .then(function () { running = false; });
  }

  function soon() { clearTimeout(timer); timer = setTimeout(run, 1200); }
  window.LBF_LABEL_SYNC = { staleLabels: staleLabels, run: run };
  document.addEventListener('cart:update', soon);
  function listen() {
    /* Dawn's own drawer remove publishes cartUpdate only; pubsub.js may load after this file. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
  else listen();
  window.addEventListener('pageshow', function () { if (/(^|;\s*)cart=/.test(document.cookie)) soon(); });
})();

/* Motion system v1 (Carl, 14 Oct 2026): the drawer's + and - flash like every stepper, then return to white. */
(function () {
  if (window.__lbfQtyFlash) return; window.__lbfQtyFlash = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer .quantity__button');
    if (!b) return;
    b.classList.add('lbf-qflash');
    setTimeout(function () { b.classList.remove('lbf-qflash'); }, 180);
  }, true);
  /* iOS Safari only applies :active (the 98% press) when the page listens for touchstart */
  document.addEventListener('touchstart', function () {}, { passive: true });
})();
